







































































































































































































































































































































































































































































































































































































import { TranslateResult } from 'vue-i18n';
import { Component, Vue, Watch, Prop } from 'vue-property-decorator';
import ConfirmDeletionModal from './ConfirmDeletionModal.vue';
import DuplicatePrevYearDataModal from './DuplicatePrevYearDataModal.vue';
import DuplicatePrevYearDataConfirmModal from './DuplicatePrevYearDataConfirmModal.vue';
import { jwtDecode } from 'jwt-decode';


interface Obl {
    code: string;
    obl: string;
    region: string;
}

interface FormField {
    key: string
    label: string | TranslateResult
    variant?: string
}

interface Subindicator {
    id: string;
    name: string;
    indicator_code: string;
    indicator_type: string | null;
    unit: string | null;
    open: boolean;
    is_jump_check: boolean;
}

interface Indicator {
    id: string;
    name: string;
    indicator_code: string;
    indicator_type: string | null;
    unit: string | null;
    open: boolean;
    subindicators: Subindicator[];
    is_jump_check: boolean; 
}

interface IndicatorRelItem {
    child: Subindicator;
    parents: Subindicator[];
}

interface IndicatorRelsDataResponse {
    data: Record<string, IndicatorRelItem>;
}

interface ComputedIndicator {
    target: string; // The indicator code that will be computed
    sources: string[]; // The indicator codes it depends on
    computeFunction: () => number | null;
}

interface srsCategory {
    id: string;
    name: string;
}

interface srsStatus {
    id: string;
    name: string;
}

interface FilterData {
    ate?: any;
    district?: any;
    ruralDistrict?: any;
    snp?: any;
    year: any;
    direction?: any;
}

interface Year {
  id: number;
  year: number;
}

interface IWaterSupplyIndicatorDto {
  year: number;
  code_kato1: string;
  code_kato2: string; 
  code_kato3: string; 
  indicator_codes: string[]; 
}

interface ISrsFormIndicatorDb {
  category_code: string; 
  category_name: string; 
  value_boolean: boolean | null;
  value_num: number | null;
  value_text: string | null;
}

interface IPrevData {
  checkedOption: string | Record<string, string>; 
  dirObj: Record<string, string>; 
  currYear: number; 
}


@Component({
    components: {
        ConfirmDeletionModal,
        DuplicatePrevYearDataModal,
        DuplicatePrevYearDataConfirmModal,
    }
})
export default class SrsForm extends Vue {
    @Prop({ default: null }) filterData!: FilterData | null;

    obl: Obl = {code: '', obl: '', region: ''};
    moduleCode = '003.009.001';
    userAccessLevel = 1; // уровень доступа пользователя по умолчанию
    currYear = new Date().getFullYear(); // system year is default
    allOpen = true;
    indicators: Indicator[] = [];
    indicatorRels: IndicatorRelsDataResponse = { data: {} };
    dirCode = '01';
    currCategory: srsCategory | null = null;
    categoriesList: srsCategory[] = [];
    currStatus: srsStatus | null = null;
    statusList: srsStatus[] = [];
    isEducation: boolean = false;
    isSaving: boolean = false;
    existingFormData: Record<string, any> = {};
    indicatorValues: Record<string, any> = {}; // Current year values for v-model
    historicalValues: Record<number, Record<string, any>> = {}; // Historical years 1-4 values
    errorIndicators: Record<string, boolean> = {}; // stores validation errors
    compAte: string = ''; // computed ATE
    oj: number = 0; // значение для показателя 08080001 из sm_data_item
    validationErrors: Record<string, string[]> = {};
    formStatus: number = 80;
    waterSupplyDisabled: boolean = false;
    waterSupplyIndicatorNames: string[] = [];
    waterSupplyIndicatorsDb: [string, ISrsFormIndicatorDb][] = [];
    prevDataDto: IPrevData = {
      checkedOption: '',
      dirObj: {},
      currYear: this.filterData!.year.year,
    };
    // non-strict flk map
    diffWarnings: Record<string, string> = {}; // indicatorId -> warning message, '' = none




    get formFields(): FormField[] {
        return [
            { key: "action", label: " " },
            { key: "name", label: this.$t('modules.srs.form.indicator') },
            { key: "unit", label: this.$t('modules.srs.form.unit') },
            { key: "year1", label: (this.currYear - 4).toString(), variant: "foobar" },
            { key: "year2", label: (this.currYear - 3).toString() },
            { key: "year3", label: (this.currYear - 2).toString(), variant: "foobar" },
            { key: "year4", label: (this.currYear - 1).toString() },
            { key: "year5", label: this.currYear.toString(), variant: "foobar" },
        ];
    }

    // computed indicators
    get computedIndicators(): ComputedIndicator[] {
      return [
          {
            target: '01030001',
            sources: [...this.generateIndicatorCodes('01', '03', 2, 7)],
            computeFunction: () => {
              const codes = [...this.generateIndicatorCodes('01', '03', 2, 7)];
              const formValues = this.getFormValues(
                  [...this.generateIndicatorCodes('01', '03', 2, 7)]
              );
              
              const allEmpty = codes.every(code => {
                const val = this.indicatorValues[code];
                return val === null || val === undefined || val === '';
              });
              if (allEmpty) return 0;

              if (this.toNumber(this.indicatorValues['01030002']) === 0)  {
                return 0;
              } 
              const wa = this.computeIndicatorWeightedAverage('01', '03', formValues);
              return wa !== null ? Math.round(wa * 10) / 10 : null;
            } 
          },
          {
            target: '01050001',
            sources: [...this.generateIndicatorCodes('01', '05', 2, 7)],
            computeFunction: () => {
              const codes = [...this.generateIndicatorCodes('01', '05', 2, 7)];
              const formValues = this.getFormValues(
                  [...this.generateIndicatorCodes('01', '05', 2, 7)]
              ); 
              const allEmpty = codes.every(code => {
                const val = this.indicatorValues[code];
                return val === null || val === undefined || val === '';
              });
              if (allEmpty) return 0;

              if (this.toNumber(this.indicatorValues['01050002']) === 0) {
                return 0;
              } 
              const wa = this.computeIndicatorWeightedAverage('01', '05', formValues);
              return wa !== null ? Math.round(wa * 10) / 10 : null;
            }
          },
          {
            target: '01060001',
            sources: [...this.generateIndicatorCodes('01', '06', 2, 7)],
            computeFunction: () => {
              const codes = [...this.generateIndicatorCodes('01', '06', 2, 7)];
              const formValues = this.getFormValues(
                  [...this.generateIndicatorCodes('01', '06', 2, 7)]
              ); 
              const allEmpty = codes.every(code => {
                const val = this.indicatorValues[code];
                return val === null || val === undefined || val === '';
              });
              if (allEmpty) return 0;

              if (this.toNumber(this.indicatorValues['01060002']) === 0) {
                return 0;
              } 
              const wa = this.computeIndicatorWeightedAverage('01', '06', formValues);
              return wa !== null ? Math.round(wa * 10) / 10 : null;
            }
          },
          {
            target: '01070001',
            sources: [...this.generateIndicatorCodes('01', '07', 2, 7)],
            computeFunction: () => {
              const codes = [...this.generateIndicatorCodes('01', '07', 2, 7)];
              const formValues = this.getFormValues(
                  [...this.generateIndicatorCodes('01', '07', 2, 7)]
              ); 
              const allEmpty = codes.every(code => {
                const val = this.indicatorValues[code];
                return val === null || val === undefined || val === '';
              });
              if (allEmpty) return 0;

              if (this.toNumber(this.indicatorValues['01070002']) === 0) {
                return 0;
              } 
              const wa = this.computeIndicatorWeightedAverage('01', '07', formValues);
              return wa !== null ? Math.round(wa * 10) / 10 : null;
            }
          },
          {
            target: '01020001',
            sources: ['01030001', '01040001', '01050001', '01060001', '01070001', '01030002', '01030005', '01040002'],
            computeFunction: () => {
              const formValues = this.getFormValues(
                  ['01030001', '01040001', '01050001', '01060001', '01070001', '01030005', '01050005', '01060005', '01070005', '01030002', '01030005']
              ); 
              const a = formValues['01030001'];
              const b = formValues['01040001'];
              const c = formValues['01050001'];
              const d = formValues['01060001'];
              const e = formValues['01070001'];
              const f = formValues['01030005'];
              const g = this.indicatorValues['01040003'];
              const h = formValues['01050005'];
              const i = formValues['01060005'];
              const j = formValues['01070005'];
              const k = formValues['01030002'];
              const l = formValues['01030005'];
              const m = this.indicatorValues['01040002'];

              if (k === 0 && l === 0 && m === 'true') {
                return 100;
              }
 
              function getN() {
                let n = 0; 
                if (a > 0 || f > 0) n += 1; 
                if (b > 0 || g === 'true') n += 1; 
                if (c > 0 || h > 0) n += 1; 
                if (d > 0 || i > 0) n += 1; 
                if (e > 0 || j > 0) n += 1;
                return n;
              }
              const n = getN();
              const numerator = [a, b, c, d, e];
              return n > 0 ? Math.round((numerator.reduce((a, b) => a + b, 0) / n)*10) / 10 : 0; 
            }
          },
          {
            target: '01020002',
            sources: ['01030001', '01040001', '01050001', '01070001', '01030002', '01030005', '01040002'],
            computeFunction: () => {
              const formValues = this.getFormValues(
                  ['01030001', '01040001', '01050001', '01070001', '01030005',
                   '01050005', '01070005', '01030002', '01030005'
                  ]
              ); 
              const a = formValues['01030001'];
              const b = formValues['01040001'];
              const c = formValues['01050001'];
              const d = formValues['01070001'];
              const e = formValues['01030005'];
              const f = this.indicatorValues['01040003']
              const g = formValues['01050005'];
              const h = formValues['01070005'];
              const i = formValues['01030002'];
              const j = formValues['01030005'];
              const k = this.indicatorValues['01040002'];

              if (i === 0 && j === 0 && k === 'true') {
                return 100;
              }
               
              function getN() {
                let n = 0; 
                if (a > 0 || e > 0) n += 1; 
                if (b > 0 || f === 'true') n += 1; 
                if (c > 0 || g > 0) n += 1; 
                if (d > 0 || h > 0) n += 1; 
                return n;
              }
              const n = getN();
              const numerator = [a, b, c, d];
              return n > 0 ? Math.round((numerator.reduce((a, b) => a + b, 0) / n)*10) / 10 : 0;
            }
          },
          {
            target: '01040001', 
            sources: ['01040002'],
            computeFunction: () => {
              const srcVal = this.indicatorValues['01040002']
              return srcVal === 'true' ? 100 : 0;
            }
          },
          {
            target: '02030001',
            sources: [...this.generateIndicatorCodes('02', '03', 2, 7)],
            computeFunction: () => {
              const codes = [...this.generateIndicatorCodes('02', '03', 2, 7)];
              const formValues = this.getFormValues(
                  [...this.generateIndicatorCodes('02', '03', 2, 7)]

              );
              const allEmpty = codes.every(code => {
                const val = this.indicatorValues[code];
                return val === null || val === undefined || val === '';
              });
              if (allEmpty) return 0;

              if (this.toNumber(this.indicatorValues['02030002']) === 0) {
                return 0;
              }
              const wa = this.computeIndicatorWeightedAverage('02', '03', formValues);
              return wa !== null ? Math.round(wa * 10) / 10 : null;
            }
          },
          {
            target: '02040001',
            sources: ['02030002', '02040002'],
            computeFunction: () => {
              const codes = ['02030002', '02040002'];
              const allEmpty = codes.every(code => {
                const val = this.indicatorValues[code];
                return val === null || val === undefined || val === '';
              });
              if (allEmpty) return 0;

              const x = this.toNumber(this.indicatorValues['02030002']);
              const y = this.toNumber(this.indicatorValues['02040002']);
              if (x === 0 || y === 0) return 0;
              const wa = (x !== null && y !== null) ? (y / x) * 100 : null;  
              return wa !== null ? Math.round(wa * 10) / 10 : null;
            }
          },
          {
            target: '02050001',
            sources: ['02050002', '02050003'],
            computeFunction: () => {
              const codes = ['02050002', '02050003'];
              const allEmpty = codes.every(code => {
                const val = this.indicatorValues[code];
                return val === null || val === undefined || val === '';
              });
              if (allEmpty) return 0;

              const x = this.toNumber(this.indicatorValues['02050003']);
              const y = this.toNumber(this.indicatorValues['02050002']);
              if (x === 0 || y === 0) return 0;
              const wa = (x !== null && y !== null) ? (x / y) * 100 : null;  
              return wa !== null ? Math.round(wa * 10) / 10 : null;
            }
          },
          {
            target: '02020001',
            sources: ['02030001', '02040001', '02050001'],
            computeFunction: () => {
              const formValues = this.getFormValues(
                  ['02030001', '02040001', '02050001', '02030005', '02030002']
              ); 

              const a = formValues['02030001'];
              const b = formValues['02040001'];
              const c = formValues['02050001'];
              const d = formValues['02030005'];
              const e = formValues['02030002'];

              function getN() {
                let n = 0; 
                if (a > 0 || d > 0) n += 1; 
                if (b > 0) n += 1; 
                if (b === 0 && (e > 0 || d > 0)) n += 1;
                if (c > 0) n += 1; 
                return n;
              }
              const n = getN();
              const numerator = [a, b, c];
              return n > 0 
                ? Math.round((numerator.reduce((a, b) => a + b, 0) / n)*10) / 10 
                : 0;
            }
          },
          {
            target: '02020002',
            sources: ['02030001', '02040001'],
            computeFunction: () => {
              const formValues = this.getFormValues(
                  ['02030001', '02040001', '02030005', '02030002']
              ); 
              const a = formValues['02030001'];
              const b = formValues['02040001'];
              const c = formValues['02030005'];
              const d = formValues['02030002'];
              
              function getN() {
                let n = 0; 
                if (a > 0 || c > 0) n += 1; 
                if (b > 0) n += 1; 
                if (b === 0 && (d > 0 || c > 0)) n += 1;
                return n;
              }
              const n = getN();
              const numerator = [a, b];
              return n > 0 
                ? Math.round((numerator.reduce((a, b) => a + b, 0) / n)*10) / 10 
                : 0;
            }
          }, 
          {
            target: '03020001',
            sources: ['03030001'],
            computeFunction: () => {
              return this.indicatorValues['03030001'];
            }
          },
          {
            target: '03020002',
            sources: ['03030001'],
            computeFunction: () => {
              return this.indicatorValues['03030001'];
            }
          },
          {
            target: '03030001',
            sources: [...this.generateIndicatorCodes('03', '03', 2, 7)],
            computeFunction: () => {
              const codes = [...this.generateIndicatorCodes('03', '03', 2, 7)];
              const formValues = this.getFormValues(
                  [...this.generateIndicatorCodes('03', '03', 2, 7)]
              ); 
              const allEmpty = codes.every(code => {
                const val = this.indicatorValues[code];
                return val === null || val === undefined || val === '';
              });
              if (allEmpty) return 0;
              
              if (this.toNumber(this.indicatorValues['03030002']) === 0) {
                return 0;
              }
              const wa = this.computeIndicatorWeightedAverage('03', '03', formValues);
              return wa !== null ? Math.round(wa * 10) / 10 : 0;
            }
          },
          {
            target: '04030001',
            sources: [...this.generateIndicatorCodes('04', '03', 2, 7)],
            computeFunction: () => {
              const codes = [...this.generateIndicatorCodes('04', '03', 2, 7)];
              const formValues = this.getFormValues(
                  [...this.generateIndicatorCodes('04', '03', 2, 7)]
              ); 
              const allEmpty = codes.every(code => {
                const val = this.indicatorValues[code];
                return val === null || val === undefined || val === '';
              });
              if (allEmpty) return 0;

              if (this.toNumber(this.indicatorValues['04030002']) === 0) {
                return 0; 
              }
              const wa = this.computeIndicatorWeightedAverage('04', '03', formValues);
              return wa !== null ? Math.round(wa * 10) / 10 : null;
            }
          },
          {
            target: '04040001',
            sources: ['04040002'],
            computeFunction: () => {
              const formValues = this.getFormValues(['04040002']);
              return formValues['04040002'] > 0 ? 100 : 0;
            }
          },
          {
            target: '04050001',
            sources: [...this.generateIndicatorCodes('04', '05', 2, 7)],
            computeFunction: () => {
              const codes = [...this.generateIndicatorCodes('04', '05', 2, 7)];
              const formValues = this.getFormValues(
                  [...this.generateIndicatorCodes('04', '05', 2, 7)]
              ); 
              const allEmpty = codes.every(code => {
                const val = this.indicatorValues[code];
                return val === null || val === undefined || val === '';
              });
              if (allEmpty) return 0;

              if (this.toNumber(this.indicatorValues['04050002']) === 0) {
                return 0; 
              }
              const wa = this.computeIndicatorWeightedAverage('04', '05', formValues);
              return wa !== null ? Math.round(wa * 10) / 10 : null;
            }
          },
          {
            target: '04060001',
            sources: [...this.generateIndicatorCodes('04', '06', 2, 7)],
            computeFunction: () => {
              const codes = [...this.generateIndicatorCodes('04', '06', 2, 7)];
              const formValues = this.getFormValues(
                  [...this.generateIndicatorCodes('04', '06', 2, 7)]
              ); 
              const allEmpty = codes.every(code => {
                const val = this.indicatorValues[code];
                return val === null || val === undefined || val === '';
              });
              if (allEmpty) return 0;

              if (this.toNumber(this.indicatorValues['04060002']) === 0) {
                return 0; 
              }
              const wa = this.computeIndicatorWeightedAverage('04', '06', formValues);
              return wa !== null ? Math.round(wa * 10) / 10 : null;
            }
          },
          {
            target: '04070001',
            sources: [...this.generateIndicatorCodes('04', '07', 2, 7)],
            computeFunction: () => {
              const codes = [...this.generateIndicatorCodes('04', '07', 2, 7)];
              const formValues = this.getFormValues(
                  [...this.generateIndicatorCodes('04', '07', 2, 7)]
              ); 
              const allEmpty = codes.every(code => {
                const val = this.indicatorValues[code];
                return val === null || val === undefined || val === '';
              });
              if (allEmpty) return 0;

              if (this.toNumber(this.indicatorValues['04070002']) === 0) {
                return 0; 
              }
              const wa = this.computeIndicatorWeightedAverage('04', '07', formValues);
              return wa !== null ? Math.round(wa * 10) / 10 : null;
            }
          },
          {
            target: '04080001',
            sources: [...this.generateIndicatorCodes('04', '08', 2, 7)],
            computeFunction: () => {
              const codes = [...this.generateIndicatorCodes('04', '08', 2, 7)];
              const formValues = this.getFormValues(
                  [...this.generateIndicatorCodes('04', '08', 2, 7)]
              ); 
              const allEmpty = codes.every(code => {
                const val = this.indicatorValues[code];
                return val === null || val === undefined || val === '';
              });
              if (allEmpty) return 0;

              if (this.toNumber(this.indicatorValues['04080002']) === 0) {
                return 0; 
              }
              const wa = this.computeIndicatorWeightedAverage('04', '08', formValues);
              return wa !== null ? Math.round(wa * 10) / 10 : null;
            }
          },
          {
            target: '04090001',
            sources: [...this.generateIndicatorCodes('04', '09', 2, 7)],
            computeFunction: () => {
              const codes = [...this.generateIndicatorCodes('04', '09', 2, 7)];
              const formValues = this.getFormValues(
                  [...this.generateIndicatorCodes('04', '09', 2, 7)]
              ); 
              const allEmpty = codes.every(code => {
                const val = this.indicatorValues[code];
                return val === null || val === undefined || val === '';
              });
              if (allEmpty) return 0;

              if (this.toNumber(this.indicatorValues['04090002']) === 0) {
                return 0; 
              }
              const wa = this.computeIndicatorWeightedAverage('04', '09', formValues);
              return wa !== null ? Math.round(wa * 10) / 10 : null;
            }
          },
          {
            target: '04100001',
            sources: [...this.generateIndicatorCodes('04', '10', 2, 7)],
            computeFunction: () => {
              const codes = [...this.generateIndicatorCodes('04', '10', 2, 7)];
              const formValues = this.getFormValues(
                  [...this.generateIndicatorCodes('04', '10', 2, 7)]
              ); 
              const allEmpty = codes.every(code => {
                const val = this.indicatorValues[code];
                return val === null || val === undefined || val === '';
              });
              if (allEmpty) return 0;

              if (this.toNumber(this.indicatorValues['04100002']) === 0) {
                return 0; 
              }
              const wa = this.computeIndicatorWeightedAverage('04', '10', formValues);
              return wa !== null ? Math.round(wa * 10) / 10 : null;
            }
          },
          {
            target: '04110001',
            sources: ['04110002'],
            computeFunction: () => {
              const formValues = this.getFormValues(['04110002']);
              const val = formValues['04110002'];
              if (val > 0) return 100;
              return 0;
            },
          },
          {
            target: '04120001',
            sources: [...this.generateIndicatorCodes('04', '12', 2, 7)],
            computeFunction: () => {
              const codes = [...this.generateIndicatorCodes('04', '12', 2, 7)];
              const formValues = this.getFormValues(
                  [...this.generateIndicatorCodes('04', '12', 2, 7)]
              ); 
              const allEmpty = codes.every(code => {
                const val = this.indicatorValues[code];
                return val === null || val === undefined || val === '';
              });
              if (allEmpty) return 0;

              if (this.toNumber(this.indicatorValues['04120002']) === 0) {
                return 0; 
              }
              const wa = this.computeIndicatorWeightedAverage('04', '12', formValues);
              return wa !== null ? Math.round(wa * 10) / 10 : null;
            }
          },
          {
            target: '04020001', 
            sources: this.generateIndicatorCodes('04', '0001', 3, 12, 1), 
            computeFunction: () => {
              const baseCodes = this.generateIndicatorCodes('04', '0001', 3, 12, 1);
              const suffix05 = [
                '04030005', '04050005', '04060005', '04070005',
                '04080005', '04090005', '04100005', '04120005',
              ];
              const formValues = this.getFormValues([...baseCodes, ...suffix05]);

              const pairs: [string, string?][] = [
                ['04030001', '04030005'],
                ['04040001'],
                ['04050001', '04050005'],
                ['04060001', '04060005'],
                ['04070001', '04070005'],
                ['04080001', '04080005'],
                ['04090001', '04090005'],
                ['04100001', '04100005'],
                ['04110001'],
                ['04120001', '04120005'],
              ];

              const N = pairs.reduce((count, [main, extra]) => {
                const mainVal = formValues[main];
                const extraVal = extra ? formValues[extra] : 0;
                return count + (mainVal > 0 || extraVal > 0 ? 1 : 0);
              }, 0);

              const numerator = pairs.map(([main]) => formValues[main] ?? 0);
              const ssum = numerator.reduce((a, b) => a + b, 0);
              return N > 0 ? Math.round((ssum / N)*10) / 10 : 0; 
            }
          },
          {
            target: '04020002', 
            sources: this.generateIndicatorCodes('04', '0001', 3, 11, 1), 
            computeFunction: () => {
              const baseCodes = this.generateIndicatorCodes('04', '0001', 3, 11, 1);
              const suffix05 = [
                '04030005', '04050005', '04060005', '04070005',
                '04080005', '04090005', '04100005',
              ];
              const formValues = this.getFormValues([...baseCodes, ...suffix05]);

              const pairs: [string, string?][] = [
                ['04030001', '04030005'],
                ['04040001'],
                ['04050001', '04050005'],
                ['04060001', '04060005'],
                ['04070001', '04070005'],
                ['04080001', '04080005'],
                ['04090001', '04090005'],
                ['04100001', '04100005'],
                ['04110001'],
              ];

              const N = pairs.reduce((count, [main, extra]) => {
                const mainVal = formValues[main];
                const extraVal = extra ? formValues[extra] : 0;
                return count + (mainVal > 0 || extraVal > 0 ? 1 : 0);
              }, 0);

              const numerator = pairs.map(([main]) => formValues[main] ?? 0);
              const ssum = numerator.reduce((a, b) => a + b, 0);
              return N > 0 ? Math.round((ssum / N)*10) / 10 : 0;
            }
          },
          {
            target: '05030001',
            sources: [...this.generateIndicatorCodes('05', '03', 2, 7)],
            computeFunction: () => {
              const codes = [...this.generateIndicatorCodes('05', '03', 2, 7)];
              const formValues = this.getFormValues(
                  [...this.generateIndicatorCodes('05', '03', 2, 7)]
              );
              const allEmpty = codes.every(code => {
                const val = this.indicatorValues[code];
                return val === null || val === undefined || val === '';
              });
              if (allEmpty) return 0;

              if (this.toNumber(this.indicatorValues['05030002']) === 0) {
                return 0; 
              }
              const wa = this.computeIndicatorWeightedAverage('05', '03', formValues);
              return wa !== null ? Math.round(wa * 10) / 10 : null;
            }
          },
          {
            target: '05040001',
            sources: ['05040002', '05040003', '05040004'],
            computeFunction: () => {
              const codes = ['05040002', '05040003', '05040004'];
              const formValues = this.getFormValues(
                  ['05040002', '05040003', '05040004']
              ); 
              const a = formValues['05040002'];
              const b = formValues['05040003'];
              const c = formValues['05040004'];
              
              const allEmpty = codes.every(code => {
                const val = this.indicatorValues[code];
                return val === null || val === undefined || val === '';
              });
              if (allEmpty) return 0;

              if (this.toNumber(this.indicatorValues['05040002']) === 0) return 0; 
              const res = ((a - (b*0.15))/(a + c))*100; 
              return Math.round(res*10) / 10;
            }
          },
          {
            target: '05050001',
            sources: ['05050002'],
            computeFunction: () => {
              return this.indicatorValues['05050002'] === 'true' ? 100 : 0; 
            }
          }, 
          {
            target: '05020001',
            sources: [...this.generateIndicatorCodes('05', '0001', 3, 5, 1)],
            computeFunction: () => {
              const formValues = this.getFormValues(
                  [...this.generateIndicatorCodes('05', '0001', 3, 5, 1), '05030005', '05040004']
              ); 
              const a = formValues['05030001'];
              const b = formValues['05040001'];
              const c = formValues['05050001'];
              const d = this.indicatorValues['05050002'];
              const e = formValues['05030005'];
              const f = formValues['05040004'];
              
              function getN() {
                let n = 0; 
                if (a > 0 || e > 0) n += 1; 
                if (b > 0 || f > 0) n += 1; 
                if (c > 0 || d === 'true') n += 1;
                return n;
              }
              const n = getN();
              const numerator = [a, b, c];
              return n > 0 
                ? Math.round((numerator.reduce((a, b) => a + b, 0) / n)*10) / 10 
                : 0;
            }
          }, 
          {
            target: '05020002',
            sources: [...this.generateIndicatorCodes('05', '0001', 3, 4, 1)],
            computeFunction: () => {
              const formValues = this.getFormValues(
                  [...this.generateIndicatorCodes('05', '0001', 3, 4, 1), '05030005', '05040004']
              ); 
              const a = formValues['05030001'];
              const b = formValues['05040001'];
              const c = formValues['05030005'];
              const d = formValues['05040004'];

              function getN() {
                let n = 0; 
                if (a > 0 || c > 0) n += 1; 
                if (b > 0 || d > 0) n += 1; 
                return n;
              }
              const n = getN();
              const numerator = [a, b];
              return n > 0 
                ? Math.round((numerator.reduce((a, b) => a + b, 0) / n)*10) / 10 
                : 0;
            },
          },
          {
            target: '06030001', 
            sources: ['06030002', 
            ...this.generateIndicatorCodes('06', '03', 5, 9), 
            ...this.generateIndicatorCodes('06', '03', 12, 16),
            ...this.generateIndicatorCodes('06', '03', 19, 29)],
            computeFunction: () => {
              const codes = ['06030002', 
                ...this.generateIndicatorCodes('06', '03', 5, 9), 
                ...this.generateIndicatorCodes('06', '03', 12, 16),
                ...this.generateIndicatorCodes('06', '03', 19, 29)
              ]; 
              const formValues = this.getFormValues(codes);
              const pairs: [string, string][] = [
                ['06030002', '06030023'],
                ['06030009', '06030024'],
                ['06030016', '06030025'],
                ['06030026', '06030027'],
                ['06030028', '06030029'],
              ];

              const N = pairs.reduce((count, [f, s]) => {
                const fVal = formValues[f];
                const sVal = formValues[s];
                return count + (fVal + sVal !== 0 ? 1 : 0);
              }, 0);

              const weights = [0.1, 0.3, 0.5, 0.8];
              const groups: [string, string[], string?][] = [
                ['06030002', ['06030005', '06030006', '06030007', '06030008'], '06030023'],
                ['06030009', ['06030012', '06030013', '06030014', '06030015'], '06030024'],
                ['06030016', ['06030019', '06030020', '06030021', '06030022'], '06030025'],
                ['06030026', [], '06030027'],
                ['06030028', [], '06030029'],
              ];

              const res = groups.map(([main, subs, extra]) => {
                const mainVal = formValues[main];
                const subVals = subs.map(c => formValues[c]);
                const extraVal = extra ? formValues[extra]: 0;

                if (subs.length === 4) {
                  const weightedSum = subVals.reduce((sum, val, idx) => sum + val * weights[idx], 0);
                  const denom = mainVal + extraVal;
                  if (denom !== 0) {
                    return (mainVal - weightedSum) / denom; 
                  } return 0; 
                }

                if (subs.length < 1 && (mainVal + extraVal) !== 0) {
                  return (mainVal / (mainVal + extraVal)); 
                } return 0;
              });
              return N > 0 
                ? Math.round(((res.reduce((sum, val) => sum + val, 0) / N)*100)*10) / 10 
                : 0;
            },
          }, 
          {
            target: '06020001',
            sources: (
              (this.filterData?.ate.code === '1' ||  this.compAte === '2') 
              ? [...this.generateIndicatorCodes('06', '0001', 3, 14, 1)]
              : (this.compAte === '3')
              ? ['06030001', ...this.generateIndicatorCodes('06', '0001', 5, 14, 1)]
              : (this.compAte === '4' || this.compAte === '5')
              ? ['06030001', ...this.generateIndicatorCodes('06', '0001', 6, 14, 1)]
              : []
            ),
            computeFunction: () => {
              const sub = ['06030023', '06030024', '06030025', '06030027', '06030029', '06030031'];
              const codes = [...this.generateIndicatorCodes('06', '0001', 3, 14, 1)]; 
              const formValues = this.getFormValues([...codes]);
              let n = 0; 
              let ssum = 0;

              if (this.filterData?.direction.code === '06') {
                if (Object.values(formValues).every(val => val === 0)) {
                  return 0; 
                }

                const getN = () => {
                  const allCodes = [...codes, ...sub, 
                    '06050003', '06070005', '06080005', '06090005'
                  ];
                  const allValues = this.getFormValues(allCodes);
                  const groups = [
                    ['06030001', '06030023', '06030024', '06030025', '06030027', '06030029', '06030031'],
                    ['06040001'],
                    ['06050001', '06050003'],
                    ['06060001'],
                    ['06070001', '06070005'],
                    ['06080001', '06080005'],
                    ['06090001', '06090005'],
                    ['06100001'],
                    ['06110001'],
                    ['06120001'],
                    ['06130001'],
                    ['06140001'],
                  ];

                  return groups.reduce(
                    (n, group) => n + (group.some(code => (allValues[code] ?? 0) > 0) ? 1 : 0),
                    0
                  );
                }

                n = getN.call(this);
                if (this.filterData.ate.code === '1' || this.compAte === '2') {
                  ssum = Object.values(formValues).reduce((sum, val) => sum + val, 0);
                } else if (this.compAte === '3') {
                  const indCodes = codes.filter(val => val !== '06040001'); 
                  ssum = indCodes
                      .map(val => formValues[val]).reduce((sum, val) => sum + val, 0);
                } else if (this.compAte === '4' || this.compAte === '5') {
                  const indCodes = codes
                      .filter(val => (val !== '06040001' && val !== '06050001')); 
                  ssum = indCodes
                      .map(val => formValues[val]).reduce((sum, val) => sum + val, 0);
                } 
              } 
              return n > 0 ? Math.round((ssum / n)*10) / 10 : 0;
            }
          },
          {
            target: '06020002',
            sources: (
              (this.filterData?.ate.code === '1' ||  this.compAte === '2') 
              ? [...this.generateIndicatorCodes('06', '0001', 3, 9, 1)]
              : (this.compAte === '3')
              ? ['06030001', ...this.generateIndicatorCodes('06', '0001', 5, 9, 1)]
              : (this.compAte === '4' || this.compAte === '5')
              ? ['06030001', ...this.generateIndicatorCodes('06', '0001', 6, 9, 1)]
              : []
            ),
            computeFunction: () => {
              const sub = ['06030023', '06030024', '06030025', '06030027', '06030029', '06030031',
                '06050003', '06070005', '06080005', '06090005' 
              ];
              const codes = [...this.generateIndicatorCodes('06', '0001', 3, 9, 1)]; 
              const formValues = this.getFormValues([...codes]);
              let n = 0; 
              let ssum = 0;

              if (this.filterData?.direction.code === '06') {
                if (Object.values(formValues).every(val => val === 0)) {
                  return 0; 
                }

                const getN = () => {
                  const allCodes = [...codes, ...sub, 
                    '06050003', '06070005', '06080005', '06090005'
                  ];
                  const allValues = this.getFormValues(allCodes);
                  const groups = [
                    ['06030001', '06030023', '06030024', '06030025', '06030027', '06030029', '06030031'],
                    ['06040001'],
                    ['06050001', '06050003'],
                    ['06060001'],
                    ['06070001', '06070005'],
                    ['06080001', '06080005'],
                    ['06090001', '06090005']
                  ];

                  return groups.reduce(
                    (n, group) => n + (group.some(code => (allValues[code] ?? 0) > 0) ? 1 : 0),
                    0
                  );
                }

                n = getN.call(this);
                if (this.filterData.ate.code === '1' || this.compAte === '2') {
                  ssum = Object.values(formValues).reduce((sum, val) => sum + val, 0);
                } else if (this.compAte === '3') {
                  const indCodes = codes.filter(val => val !== '06040001'); 
                  ssum = indCodes
                      .map(val => formValues[val]).reduce((sum, val) => sum + val, 0);
                } else if (this.compAte === '4' || this.compAte === '5') {
                  const indCodes = codes
                      .filter(val => (val !== '06040001' && val !== '06050001')); 
                  ssum = indCodes
                      .map(val => formValues[val]).reduce((sum, val) => sum + val, 0);
                } 
              } 
              return n > 0 ? Math.round((ssum / n)*10) / 10 : 0;
            }
          },
          {
            target: '06040001',
            sources: ['06040002'],
            computeFunction: () => {
              const srcVal = this.indicatorValues['06040002']
              if (srcVal === 'true') 
                return 100; 
              return 0;
            }
          }, 
          {
            target: '06050001', 
            sources: ['06050002', '06050003'],
            computeFunction: () => {
              if (this.indicatorValues['06050002'] === 'true') {
                const val030 = this.toNumber(this.indicatorValues['06050003']) || 0;
                if (val030 === 0) {
                  return 100;
                } else if (val030 > 0) {
                  return 75;
                }
              } 
              return 0;
            }
          },
          {
            target: '06060001', 
            sources: ['06060002', '06060003'],
            computeFunction: () => {
              const val02 = this.indicatorValues['06060002'];
              const val03 = this.indicatorValues['06060003'];
              if (val02 === 'true' && val03 === 'false') {
                return 100;
              } else if (val02 === 'true' && val03 === 'true') {
                return 75;
              } else if (val02 === 'false') {
                return 0;
              }
              return 0; 
            }
          },
          {
            target: '06070001', 
            sources: ['06070002', '06070003'],
            computeFunction: () => {
              const val02 = this.indicatorValues['06070002'];
              const val03 = this.indicatorValues['06070003'];
              if (val02 === 'true' && val03 === 'false') {
                return 100;
              } else if (val02 === 'true' && val03 === 'true') {
                return 75;
              } else if (val02 === 'false') {
                return 0;
              }
              return 0; 
            }
          },
          {
            target: '06080001', 
            sources: ['06080002', '06080003'],
            computeFunction: () => {
              const val02 = this.indicatorValues['06080002'];
              const val03 = this.indicatorValues['06080003'];
              if (val02 === 'true' && val03 === 'false') {
                return 100;
              } else if (val02 === 'true' && val03 === 'true') {
                return 75;
              } else if (val02 === 'false') {
                return 0;
              }
              return 0; 
            }
          },
          {
            target: '06090001', 
            sources: ['06090002', '06090003'],
            computeFunction: () => {
              const val02 = this.indicatorValues['06090002'];
              const val03 = this.indicatorValues['06090003'];
              if (val02 === 'true' && val03 === 'false') {
                return 100;
              } else if (val02 === 'true' && val03 === 'true') {
                return 75;
              } else if (val02 === 'false') {
                return 0;
              }
              return 0; 
            }
          },
          {
            target: '06100001', 
            sources: ['06100002'],
            computeFunction: () => {
              const val = this.indicatorValues['06100002'];
              return val === 'true' ? 100 : val === 'false' ? 0 : 0;
            }
          },
          {
            target: '06110001', 
            sources: ['06110002'],
            computeFunction: () => {
              const val = this.indicatorValues['06110002'];
              return val === 'true' ? 100 : val === 'false' ? 0 : 0;
            }
          },
          {
            target: '06120001', 
            sources: ['06120002'],
            computeFunction: () => {
              const val = this.indicatorValues['06120002'];
              return val === 'true' ? 100 : val === 'false' ? 0 : 0;
            }
          },
          {
            target: '06130001', 
            sources: ['06130002'],
            computeFunction: () => {
              const val = this.indicatorValues['06130002'];
              return val === 'true' ? 100 : val === 'false' ? 0 : 0;
            }
          },
          {
            target: '06140001', 
            sources: ['06140002'],
            computeFunction: () => {
              const val = this.indicatorValues['06140002'];
              return val === 'true' ? 100 : val === 'false' ? 0 : 0;
            }
          },
          {
            target: '06030002', 
            sources: [...this.generateIndicatorCodes('06', '03', 4, 8)], 
            computeFunction: () => {
              const codes = [...this.generateIndicatorCodes('06', '03', 4, 8)];
              const formValues = this.getFormValues([
                ...this.generateIndicatorCodes('06', '03', 4, 8)
              ]);
              
              const allEmpty = codes.every(code => {
                const val = this.indicatorValues[code];
                return val === null || val === undefined || val === '';
              });
              if (allEmpty) return 0;

              const ssum = Object.values(formValues).reduce(
                (acc, val) => acc + val, 0
              );
              return Math.round(ssum*10) / 10;
            }
          }, 
          {
            target: '06030009', 
            sources: [...this.generateIndicatorCodes('06', '03', 11, 15)],
            computeFunction: () => {
              const codes = [...this.generateIndicatorCodes('06', '03', 11, 15)];
              const formValues = this.getFormValues([
                ...this.generateIndicatorCodes('06', '03', 11, 15)
              ]);

              const allEmpty = codes.every(code => {
                const val = this.indicatorValues[code];
                return val === null || val === undefined || val === '';
              });
              if (allEmpty) return 0; 

              const ssum = Object.values(formValues).reduce(
                (acc, val) => acc + val, 0
              );
              return Math.round(ssum*10) / 10;
            }
          },
          {
            target: '06030016', 
            sources: [...this.generateIndicatorCodes('06', '03', 18, 22)],
            computeFunction: () => {
              const codes = [...this.generateIndicatorCodes('06', '03', 18, 22)];
              const formValues = this.getFormValues([
                ...this.generateIndicatorCodes('06', '03', 18, 22)
              ]);

              const allEmpty = codes.every(code => {
                const val = this.indicatorValues[code];
                return val === null || val === undefined || val === '';
              });
              if (allEmpty) return 0; 

              const ssum = Object.values(formValues).reduce(
                (acc, val) => acc + val, 0
              );
              return Math.round(ssum*10) / 10;
            }
          },
          {
            target: '07030001', 
            sources: [...this.generateIndicatorCodes('07', '03', 2, 6)],
            computeFunction: () => {
              const codes = [...this.generateIndicatorCodes('07', '03', 2, 6)];
              const allEmpty = codes.every(code => {
                const val = this.indicatorValues[code];
                return val === null || val === undefined || val === '';
              });
              if (allEmpty) return 0; 

              const formValues = this.getFormValues(
                  [...this.generateIndicatorCodes('07', '03', 2, 6)]
              );
              const a = formValues['07030002'];
              const b = formValues['07030003'];
              const c = formValues['07030004'];
              const d = formValues['07030005'];
              const e = formValues['07030006'];
              const f = (a - b*0.3) / (a + c); 
              const g = (d - e*0.3) / d;
              const validParts = [f, g].filter(Number.isFinite);

              const N = (d === 0 ? 1 : 2);
              return validParts.length > 0 
                ? Math.round(((validParts.reduce((sum, val) => sum + val, 0) / N)*100)*10) / 10
                : 0;
            }
          },
          {
            target: '07040001',
            sources: ['07040002', '07040003', '07040004'],
            computeFunction: () => {
              const codes = ['07040002', '07040003', '07040004'];
              const formValues = this.getFormValues(
                  ['07040002', '07040003', '07040004']
              ); 

              const allEmpty = codes.every(code => {
                const val = this.indicatorValues[code];
                return val === null || val === undefined || val === '';
              });
              if (allEmpty) return 0; 

              const a = formValues['07040002'];
              const b = formValues['07040003'];
              const c = formValues['07040004'];

              const s = (b/(b + c))*100; 
              const validParts = [a, s].filter(Number.isFinite);
              return validParts.length > 0 
                ? Math.round(((validParts.reduce((sum, val) => sum + val, 0) / 2))*10) / 10
                : 0; 
            }
          },
          {
            target: '07020001',
            sources: ['07030001', '07040001'],
            computeFunction: () => {
              const formValues = this.getFormValues(['07030001', '07040001']);
              const res = (formValues['07030001'] + formValues['07040001']) / 2;
              return Math.round(res * 10) / 10;
            }
          },
          {
            target: '07020002',
            sources: ['07030001', '07040001'],
            computeFunction: () => {
              const formValues = this.getFormValues(['07030001', '07040001']);
              const res = (formValues['07030001'] + formValues['07040001']) / 2;
              return Math.round(res * 10) / 10;
            }
          },
          {
            target: '08030001',
            sources: [...this.generateIndicatorCodes('08', '03', 2, 6)],
            computeFunction: () => {
              const codes = [...this.generateIndicatorCodes('08', '03', 2, 6)];
              const formValues = this.getFormValues(
                  [...this.generateIndicatorCodes('08', '03', 2, 6)]
              );
              const allEmpty = codes.every(code => {
                const val = this.indicatorValues[code];
                return val === null || val === undefined || val === '';
              });
              if (allEmpty) return 0;

              if (this.toNumber(this.indicatorValues['08030003']) === 0)  {
                return 0;
              }

              const a = formValues['08030002'];
              const b = formValues['08030003'];
              const c = formValues['08030004'];
              const d = formValues['08030005'];
              const e = formValues['08030006'];

              const f = ((b - d*0.3)/(b + e))*100; 
              const validParts = [a, f, 100-c].filter(Number.isFinite);
              if (validParts.length > 0) {
                if (Object.values(formValues).every(val => val === 0)) {
                  return 0; 
                } return Math.round((validParts.reduce((sum, val) => sum + val, 0) / 3)*10) / 10;
              }
              return 0; 
            }
          }, 
          {
            target: '08040001',
            sources: ['08040003', '08040004', '08040006', '08040007', '08040008', '08040009', '08040010'],
            computeFunction: () => {
              const formValues = this.getFormValues(
                  ['08040004', '08040005', '08040006', '08040007', '08040008', '08040009']
              ); 
              const a = this.indicatorValues['08040003'];
              const b = formValues['08040004'];
              const c = formValues['08040006'];
              const d = formValues['08040007'];
              const e = formValues['08040008'];
              const f = formValues['08040009'];
              const k = formValues['08040005'];
              const g = this.indicatorValues['08040010'] === 'true' ? 'true' : 'false';
              
              const h = (c - (e*0.3))/(c + f)*100;
              const i = (100 - d); 
              const j = (100 - b)*0.9;
              
              if (a === 'true' && g === 'true') {
                const validParts = [b, h, i, j].filter(Number.isFinite);
                return validParts.length > 0 ? Math.round((validParts.reduce((sum, val) => sum + val, 0) / 4)*10) / 10 : 0;
              } else if (a === 'true' && g === 'false') {
                const validParts = [b, h, i].filter(Number.isFinite);
                return validParts.length > 0 ? Math.round((validParts.reduce((sum, val) => sum + val, 0) / 3)*10) / 10 : 0;
              } else if (a === 'false' && f > 0) { 
                return 45 
              } else if (a === 'false' && f === 0) { 
                return 90 
              }
              return 0; 
            }
          }, 
          {
            target: '08050001',
            sources: [...this.generateIndicatorCodes('08', '05', 2, 9)],
            computeFunction: () => {
              const codes = [...this.generateIndicatorCodes('08', '05', 2, 9)];
              const formValues = this.getFormValues(
                  [...this.generateIndicatorCodes('08', '05', 2, 9)]
              ); 
              const allEmpty = codes.every(code => {
                const val = this.indicatorValues[code];
                return val === null || val === undefined || val === '';
              });
              if (allEmpty) return 0;

              if (this.toNumber(this.indicatorValues['08050003']) === 0)  {
                return 0;
              }
              
              const a = formValues['08050002'];
              const b = formValues['08050003'];
              const c = formValues['08050004'];
              const d = formValues['08050005'];
              const e = formValues['08050006'];
              const f = formValues['08050007'];
              const g = formValues['08050008'];
              const h = formValues['08050009']; 
  
              const i = (b - (d*0.3))/(b + e)*100;
              const j = (c === 0) ? 0 : 100 - c;  
              const k = (f/(f + h))*100;
              const l = (g === 0) ? 0 : 100 - g; 

              let n = 5;
              if (f <= 0 && h >= 0) { // case 6
                n -= 1; 
              } else if (f <= 0 && h < 0) { // sase 7
                n -= 2;
              } else if (f > 0 && h < 0) { // case 5
                n -= 1;
              } 

              const validParts = [a, i, j, k, l].filter(Number.isFinite);
              return validParts.length > 0 ? Math.round((validParts.reduce((sum, val) => sum + val, 0) / n)*10) / 10 : 0;
            }
          }, 
          {
            target: '08060001',
            sources: [...this.generateIndicatorCodes('08', '06', 2, 6)],
            computeFunction: () => {
              const codes = [...this.generateIndicatorCodes('08', '06', 2, 6)];
              const formValues = this.getFormValues(
                  [...this.generateIndicatorCodes('08', '06', 2, 6)]
              ); 

              const allEmpty = codes.every(code => {
                const val = this.indicatorValues[code];
                return val === null || val === undefined || val === '';
              });
              if (allEmpty) return 0;

              if (this.toNumber(this.indicatorValues['08060002']) === 0)  {
                return 0;
              }

              const a = formValues['08060002'];
              const b = formValues['08060003'];
              const c = formValues['08060004'];
              const d = formValues['08060005'];
              const e = formValues['08060006'];
              const f = (b - (d*0.3))/(b + e)*100;
              const g = (c === 0) ? 0 : 100 - c;
            
              const validParts = [a, f, g].filter(Number.isFinite);
              return validParts.length > 0 ? Math.round((validParts.reduce((sum, val) => sum + val, 0) / 3)*10) / 10 : 0;
            }
          }, 
          {
            target: '08070001',
            sources: [...this.generateIndicatorCodes('08', '07', 2, 6)],
            computeFunction: () => {
              const codes = [...this.generateIndicatorCodes('08', '07', 2, 6)];
              const formValues = this.getFormValues(
                  [...this.generateIndicatorCodes('08', '07', 2, 6)]
              ); 
 
              const allEmpty = codes.every(code => {
                const val = this.indicatorValues[code];
                return val === null || val === undefined || val === '';
              });
              if (allEmpty) return 0;

              if (this.toNumber(this.indicatorValues['08070002']) === 0 || this.toNumber(this.indicatorValues['08070003']) === 0)  {
                return 0;
              }

              const a = formValues['08070002'];
              const b = formValues['08070003'];
              const c = formValues['08070004'];
              const d = formValues['08070005'];
              const e = formValues['08070006'];
              const f = (b - (d*0.3))/(b + e)*100;
              const g = 100 - c;
            
              const validParts = [a, f, g].filter(Number.isFinite);
              return validParts.length > 0 ? Math.round((validParts.reduce((sum, val) => sum + val, 0) / 3)*10) / 10 : 0;
            }
          }, 
          {
            target: '08080001',
            sources: [...this.generateIndicatorCodes('08', '08', 2, 5)],
            computeFunction: () => {
              const codes = [...this.generateIndicatorCodes('08', '08', 2, 5)];
              const formValues = this.getFormValues(
                  [...this.generateIndicatorCodes('08', '08', 2, 5)]
              ); 
              const allEmpty = codes.every(code => {
                const val = this.indicatorValues[code];
                return val === null || val === undefined || val === '';
              });
              if (allEmpty) return 0; 

              if (this.toNumber(this.indicatorValues['08080002']) === 0) return 0;

              const a = this.oj;
              const b = formValues['08080002'];
              const c = formValues['08080003'];
              const d = formValues['08080004'];
              const e = formValues['08080005'];

              const f = (b - (d*0.9))/(b + e);
              const g = (c / a) > 1 ? 1 : c / a  
            
              const validParts = [f, g].filter(Number.isFinite);
              if (validParts.length > 0) {
                const res = (validParts.reduce((sum, val) => sum + val, 0) / 2) * 100;  
                return Math.round(res * 10) / 10;
              } return 0; 
            }
          },
          {
            target: '08020001',
            sources: [...this.generateIndicatorCodes('08', '0001', 3, 8, 1)], 
            computeFunction: () => {
              const codes = [...this.generateIndicatorCodes('08', '0001', 3, 8, 1)];
              const formValues = this.getFormValues([
                ...this.generateIndicatorCodes('08', '0001', 3, 8, 1)
              ]); 
              const allEmpty = codes.every(code => {
                const val = this.indicatorValues[code];
                return val === null || val === undefined || val === '';
              });
              if (allEmpty) return 0;

              const a = formValues['08030001'];
              const b = formValues['08040001'];
              const c = formValues['08050001'];
              const d = formValues['08060001'];
              const e = formValues['08070001'];
              const f = formValues['08080001'];
              const g = this.toNumber(this.indicatorValues['08030006']);
              const h = this.toNumber(this.indicatorValues['08040009']);
              const i = this.toNumber(this.indicatorValues['08050006']);
              const j = this.toNumber(this.indicatorValues['08060006']);
              const k = this.toNumber(this.indicatorValues['08070006']);
              const l = this.toNumber(this.indicatorValues['08080005']);

              
              function getN() {
                let n = 0;
                const nums = [[a, g], [b, h], [c, i], [d, j], [e, k], [f, l]];
                for (const [x, y] of nums) {
                  ((x && x > 0) || (y && y > 0)) && n++
                }
                return n;
              }

              const n = getN();
              const vals = Object.values(formValues);
              return n > 0 ? Math.round((vals.reduce((sum, val) => sum + val, 0) / n)*10) / 10 : 0;
            }
          },
          {
            target: '08020002',
            sources: [...this.generateIndicatorCodes('08', '0001', 3, 6, 1), '08080001'], 
            computeFunction: () => {
              const formValues = this.getFormValues(
                [...this.generateIndicatorCodes('08', '0001', 3, 6, 1), '08080001']
              ); 
              const a = this.toNumber(this.indicatorValues['08030001']);
              const b = this.toNumber(this.indicatorValues['08040001']);
              const c = this.toNumber(this.indicatorValues['08050001']);
              const d = this.toNumber(this.indicatorValues['08060001']);
              const e = formValues['08080001'];
              const f = this.toNumber(this.indicatorValues['08030006']);
              const g = this.toNumber(this.indicatorValues['08040009']);
              const h = this.toNumber(this.indicatorValues['08050006']);
              const i = this.toNumber(this.indicatorValues['08060006']);
              const j = this.toNumber(this.indicatorValues['08080005']);
              
              function getN() {
                let n = 0;
                const nums = [[a, f], [b, g], [c, h], [d, i], [e, j]];
                for (const [x, y] of nums) {
                  ((x && x > 0) || (y && y > 0)) && n++
                }
                return n;
              }
              const n = getN();
              const vals = Object.values(formValues);
              return n > 0 ? Math.round((vals.reduce((sum, val) => sum + val, 0) / n)*10) / 10 : 0;
            }
          },
          {
            target: '09030001',
            sources: [...this.generateIndicatorCodes('09', '03', 2, 8)],
            computeFunction: () => {
              const codes = [...this.generateIndicatorCodes('09', '03', 2, 8)];
              const allEmpty = codes.every(code => {
                const val = this.indicatorValues[code];
                return val === null || val === undefined || val === '';
              });
              if (allEmpty) return 0; 

              const formValues = this.getFormValues(
                  [...this.generateIndicatorCodes('09', '03', 2, 7)]
              ); 
              const a = this.toNumber(this.indicatorValues['09030002']);

              if (a === 0) return 0;
              if (this.indicatorValues['09030008'] === 'true') {
                return 100; 
              } else if (this.indicatorValues['09030008'] === 'false') {
                return 0; 
              } 

              const wa = this.computeIndicatorWeightedAverage('09', '03', formValues);
              return wa !== null ? Math.round(wa * 10) / 10 : 0;
            }
          },
          {
            target: '09050001',
            sources: [...this.generateIndicatorCodes('09', '05', 2, 5)],
            computeFunction: () => {
              const codes = [...this.generateIndicatorCodes('09', '05', 2, 5)];
              const formValues = this.getFormValues(
                  [...this.generateIndicatorCodes('09', '05', 2, 5)]
              ); 
              const allEmpty = codes.every(code => {
                const val = this.indicatorValues[code];
                return val === null || val === undefined || val === '';
              });
              if (allEmpty) return 0;

              const x = this.toNumber(this.indicatorValues['09050002']);
              const y = this.toNumber(this.indicatorValues['09050003']);

              if (x !== null && y !== null && (x + y === 0)) {
                return 0;
              }

              const a = formValues['09050002'];
              const b = formValues['09050003'];
              const c = formValues['09050004'];
              const d = formValues['09050005'];

              const e = (c / (a + b));
              const f = 1 - (d/100)*0.9;
              const validParts = [e, f].filter(Number.isFinite);

              const res =
                validParts.length > 0
                  ? validParts.reduce((prod, val) => prod * val, 1) * 100
                  : 0;
              return res !== null ? Math.round(res * 10) / 10 : 0;
            }
          },
          {
            target: '09060001',
            sources: [...this.generateIndicatorCodes('09', '06', 2, 5)],
            computeFunction: () => {
              const codes = [...this.generateIndicatorCodes('09', '06', 2, 5)];
              const formValues = this.getFormValues(
                  [...this.generateIndicatorCodes('09', '06', 2, 5)]
              ); 
              const allEmpty = codes.every(code => {
                const val = this.indicatorValues[code];
                return val === null || val === undefined || val === '';
              });
              if (allEmpty) return 0;

              if (this.toNumber(this.indicatorValues['09060002']) === 0) return 0;

              const a = formValues['09060002'];
              const b = formValues['09060003'];
              const c = formValues['09060004'];
              const d = formValues['09060005'];

              const e = (a - d*0.15)/(a + b); 
              const f = (a - c*0.1)/a;
              const validParts = [e, f].filter(Number.isFinite);

              const res =
                validParts.length > 0
                  ? (validParts.reduce((sum, val) => sum + val, 0)/2)*100
                  : 0;
              return res !== null ? Math.round(res * 10) / 10 : 0;
            }
          }, 
          {
            target: '09070001',
            sources: [...this.generateIndicatorCodes('09', '07', 2, 4)],
            computeFunction: () => {
              const codes = [...this.generateIndicatorCodes('09', '07', 2, 4)];
              const formValues = this.getFormValues(
                  [...this.generateIndicatorCodes('09', '07', 2, 4)]
              );
              const allEmpty = codes.every(code => {
                const val = this.indicatorValues[code];
                return val === null || val === undefined || val === '';
              });
              if (allEmpty) return 0;

              if (this.toNumber(this.indicatorValues['09070002']) === 0) return 0;

              const a = formValues['09070002'];
              const b = formValues['09070003'];
              const c = formValues['09070004'];
              const e = (b / (a + c)) * 100;
              const validParts = [e].filter(Number.isFinite);

              const res = validParts.length > 0 ? e : 0;
              return res !== null ? Math.round(res * 10) / 10 : 0;
            }
          },
          {
            target: '09080001',
            sources: [...this.generateIndicatorCodes('09', '08', 2, 3)],
            computeFunction: () => {
              const codes = [...this.generateIndicatorCodes('09', '08', 2, 3)];
              const formValues = this.getFormValues(
                  [...this.generateIndicatorCodes('09', '08', 2, 3)]
              );
              const allEmpty = codes.every(code => {
                const val = this.indicatorValues[code];
                return val === null || val === undefined || val === '';
              });
              if (allEmpty) return 0;

              if (this.toNumber(this.indicatorValues['09080002']) === 0) return 0;

              const a = formValues['09080002'];
              const b = formValues['09080003'];
              const c = (a / (b + a)) * 100;
              const validParts = [c].filter(Number.isFinite);

              const res = validParts.length > 0 ? c : 0;
              return res !== null ? Math.round(res * 10) / 10 : 0;
            }
          },
          {
            target: '09090001',
            sources: [...this.generateIndicatorCodes('09', '09', 2, 3)],
            computeFunction: () => {
              const codes = [...this.generateIndicatorCodes('09', '09', 2, 3)];
              const formValues = this.getFormValues(
                  [...this.generateIndicatorCodes('09', '09', 2, 3)]
              );
              const allEmpty = codes.every(code => {
                const val = this.indicatorValues[code];
                return val === null || val === undefined || val === '';
              });
              if (allEmpty) return 0;

              if (this.toNumber(this.indicatorValues['09090002']) === 0) return 0;

              const a = formValues['09090002'];
              const b = formValues['09090003'];
              const c = (a / (a + b)) * 100;
              const validParts = [c].filter(Number.isFinite);

              const res = validParts.length > 0 ? c : 0;
              return res !== null ? Math.round(res * 10) / 10 : 0;
            }
          },
          {
            target: '09100001',
            sources: [...this.generateIndicatorCodes('09', '10', 2, 3)],
            computeFunction: () => {
              const codes = [...this.generateIndicatorCodes('09', '10', 2, 3)];
              const formValues = this.getFormValues(
                  [...this.generateIndicatorCodes('09', '10', 2, 3)]
              ); 
              const allEmpty = codes.every(code => {
                const val = this.indicatorValues[code];
                return val === null || val === undefined || val === '';
              });
              if (allEmpty) return 0;

              const x = this.toNumber(this.indicatorValues['09100002']); 
              const y = this.toNumber(this.indicatorValues['09100003']);
              if (x !== null && y !== null && (x + y === 0)) return 0;
              
              const a = formValues['09100002'];
              const b = formValues['09100003'];
              const c = (a / (a + b)) * 100;
              const validParts = [c].filter(Number.isFinite);

              const res = validParts.length > 0 ? c : 0;
              return res !== null ? Math.round(res * 10) / 10 : 0;
            }
          },
          {   
            target: '09110001',
            sources: [...this.generateIndicatorCodes('09', '11', 2, 3)],
            computeFunction: () => {
              const codes = [...this.generateIndicatorCodes('09', '11', 2, 3)];
              const allEmpty = codes.every(code => {
                const val = this.indicatorValues[code];
                return val === null || val === undefined || val === '';
              });
              if (allEmpty) return 0; 

              const formValues = this.getFormValues(
                  [...this.generateIndicatorCodes('09', '11', 2, 3)]
              ); 

              const a = formValues['09110002'];
              const b = formValues['09110003'];
              const c = (a / (a + b)) * 100;
              const validParts = [c].filter(Number.isFinite);

              const res = validParts.length > 0 ? c : 0;
              return res !== null ? Math.round(res * 10) / 10 : 0;
            }
          },
          {
            target: '09120001',
            sources: [...this.generateIndicatorCodes('09', '12', 2, 3)],
            computeFunction: () => {
              const codes = [...this.generateIndicatorCodes('09', '12', 2, 3)];
              const formValues = this.getFormValues(
                  [...this.generateIndicatorCodes('09', '12', 2, 3)]
              ); 
              const allEmpty = codes.every(code => {
                const val = this.indicatorValues[code];
                return val === null || val === undefined || val === '';
              });
              if (allEmpty) return 0;

              if (this.toNumber(this.indicatorValues['09120002']) === 0) return 0; 
              const a = formValues['09120002'];
              const b = formValues['09120003'];
              const c = (a / (a + b)) * 100;
              const validParts = [c].filter(Number.isFinite);

              const res = validParts.length > 0 ? c : 0;
              return res !== null ? Math.round(res * 10) / 10 : 0;
            }
          },
          {
            target: '09130001',
            sources: [...this.generateIndicatorCodes('09', '13', 2, 3)],
            computeFunction: () => {
              const codes = [...this.generateIndicatorCodes('09', '13', 2, 3)];
              const formValues = this.getFormValues(
                  [...this.generateIndicatorCodes('09', '13', 2, 3)]
              );
              const allEmpty = codes.every(code => {
                const val = this.indicatorValues[code];
                return val === null || val === undefined || val === '';
              });
              if (allEmpty) return 0;

              if (this.toNumber(this.indicatorValues['09130002']) === 0) return 0;

              const a = formValues['09130002'];
              const b = formValues['09130003'];
              const c = (a / (a + b)) * 100;
              const validParts = [c].filter(Number.isFinite);

              const res = validParts.length > 0 ? c : 0;
              return res !== null ? Math.round(res * 10) / 10 : 0;
            }
          },
          {
            target: '09020001',
            sources: [...this.generateIndicatorCodes('09', '0001', 3, 13, 1)],
            computeFunction: () => {
              const codes = [...this.generateIndicatorCodes('09', '0001', 3, 13, 1)];
              const allEmpty = codes.every(code => {
                const val = this.indicatorValues[code];
                return val === null || val === undefined || val === '';
              });
              if (allEmpty) return 0; 

              const formValues = this.getFormValues(
                [...this.generateIndicatorCodes('09', '0001', 3, 13, 1)]
              );
              const subValues = this.getFormValues(
                ['09030005', '09050003', '09060003', '09070004', '09080003', 
                 '09090003', '09100003', '09110003', '09120003', '09130003']
              );

              const getN = () => {
                const groups = [
                  ['09030001', '09030005'],
                  ['09050001', '09050003'],
                  ['09060001', '09060003'],
                  ['09070001', '09070004'],
                  ['09080001', '09080003'],
                  ['09090001', '09090003'],
                  ['09100001', '09100003'],
                  ['09110001', '09110003'],
                  ['09120001', '09120003'],
                  ['09130001', '09130003'],
                ]

                let n = 0;
                for (const group of groups) {
                  const [mainCode, subCode] = group;
                  const mainVal = this.toNumber(this.indicatorValues[mainCode]) || 0;
                  const subVal = this.toNumber(this.indicatorValues[subCode]) || 0;
                  if ((mainVal > 0) || (subVal > 0)) n++; 
                }
                const a = this.toNumber(this.indicatorValues['09040001']) || 0;
                const b = this.indicatorValues['09040002'];
                n += (a > 0 || b === 'true') ? 1 : 0;
                return n; 
              }
              
              const N = getN();
              const vals = [...Object.values(formValues)];
              return N > 0 ? Math.round((vals.reduce((a, b) => a + b, 0) / N)*10) / 10 : 0;
            }
          },
          {
            target: '09020002',
            sources: ['09030001', ...this.generateIndicatorCodes('09', '0001', 5, 11, 1), '09130001'],
            computeFunction: () => {
              const formValues = this.getFormValues(
                ['09030001', ...this.generateIndicatorCodes('09', '0001', 5, 11, 1), '09130001']
              );
              const subValues = this.getFormValues(
                ['09030005', ' 09050003', '09060003', '09070004', '09080003', '09090003', '09100003', '09110003', '09130003']
              );

              const getN = () => {
                const groups = [
                  ['09030001', '09030005'],
                  ['09050001', '09050003'],
                  ['09060001', '09060003'],
                  ['09070001', '09070004'],
                  ['09080001', '09080003'],
                  ['09090001', '09090003'],
                  ['09100001', '09100003'],
                  ['09110001', '09110003'],
                  ['09130001', '09130003'],
                ]

                let n = 0;
                for (const group of groups) {
                  const [mainCode, subCode] = group;
                  const mainVal = this.toNumber(this.indicatorValues[mainCode]) || 0;
                  const subVal = this.toNumber(this.indicatorValues[subCode]) || 0;
                  if (mainVal > 0 || subVal > 0) n++; 
                }
                return n; 
              }

              const N = getN();
              const vals = [...Object.values(formValues)];
              return N > 0 ? Math.round((vals.reduce((a, b) => a + b, 0) / N)*10) / 10 : 0;
            }
          },
          {
            target: '09040001', 
            sources: ['09040002'],
            computeFunction: () => {
              const srcVal = this.indicatorValues['09040002']
              return srcVal === 'true' ? 100 : 0;
            }
          },
          {
            target: '10030001', 
            sources: [...this.generateIndicatorCodes('10', '03', 2, 4)],
            computeFunction: () => {
              const formValues = this.getFormValues(
                  [...this.generateIndicatorCodes('10', '03', 2, 4)]              

              ); 
              const a = formValues['10030002'];
              const b = formValues['10030003'];
              const c = formValues['10030004'];

              if (a === 0 && b === 0) return 0.5 * c;
              
              const validParts = [a/(a + b)*100, c].filter(Number.isFinite);

              const res =
                validParts.length > 0
                  ? Math.round((validParts.reduce((sum, val) => sum + val, 0) / 2)*10) / 10
                  : 0;
              return res;
            }
          }, 
          {
            target: '10020001',
            sources: [...this.generateIndicatorCodes('10', '0001', 3, 7, 1)],
            computeFunction: () => {
              const sub = this.getFormValues(['10030003']);
              const formValues = this.getFormValues(
                  [...this.generateIndicatorCodes('10', '0001', 3, 7, 1)]
              );
              if (Object.values(formValues).every(val => val === 0)) {
                  return 0; 
              }
              const getN = () => {
                let n = 3;
                if (sub["10030003"] > 0 || formValues["10030001"] > 0) n++; 
                if (formValues["10070001"] > 0) n++;
                return n;
              };

              const n = getN();
              return n > 0 
                ? Math.round((Object.values(formValues).reduce((a, b) => a + b, 0) / n)*10) / 10 
                : 0;
            }
          }, 
          {
            target: '10020002',
            sources: [...this.generateIndicatorCodes('10', '0001', 4, 6, 1)],
            computeFunction: () => {
              const formValues = this.getFormValues(
                  [...this.generateIndicatorCodes('10', '0001', 4, 6, 1)]
              );
              if (Object.values(formValues).every(val => val === 0)) {
                  return 0; 
              }
              return Math.round((Object.values(formValues).reduce((a, b) => a + b, 0) / 3)*10) / 10; 
            }
          },
          {
            target: '10040001',
            sources: ['10040002'],
            computeFunction: () => {
                const srcVal = this.indicatorValues['10040002']; 
                return srcVal === 'true' ? 100 : 0;
            }
          },
          {
            target: '10050001', 
            sources: ['10050004'],
            computeFunction: () => {
              return this.indicatorValues['10050004'] || 0;
            }
          }, 
          {
            target: '10060001',
            sources: ['10060002'],
            computeFunction: () => {
              const srcVal = this.indicatorValues['10060002'];
              return srcVal === 'true' ? 100 : 0;
            }
          },
          {
            target: '10070001',
            sources: ['10070002'],
            computeFunction: () => {
              const srcVal = this.indicatorValues['10070002'];
              return srcVal === 'true' ? 100 : 0;
            }
          },
          {
            target: '11050001',
            sources: [...this.generateIndicatorCodes('11', '05', 2, 7)],
            computeFunction: () => {
              const codes = [...this.generateIndicatorCodes('11', '05', 2, 7)];
              const formValues = this.getFormValues(
                  [...this.generateIndicatorCodes('11', '05', 2, 7)]
              ); 
              const allEmpty = codes.every(code => {
                const val = this.indicatorValues[code];
                return val === null || val === undefined || val === '';
              });
              if (allEmpty) return 0;
              
              if (this.toNumber(this.indicatorValues['11050002']) === 0) return 0; 
              const wa = this.computeIndicatorWeightedAverage('11', '05', formValues);
              return wa !== null ? Math.round(wa * 10) / 10 : 0;
            }
          }, 
          {
            'target': '11020001',
            'sources': [...this.generateIndicatorCodes('11', '0001', 3, 5, 1)],
            computeFunction: () => {
              const sub = this.getFormValues(['11050005'])
              const formValues = this.getFormValues(
                  [...this.generateIndicatorCodes('11', '0001', 3, 5, 1)]   
              );
              if (Object.values(formValues).every(val => val === 0)) {
                  return 0;  
              }           
              const getN = () => {
                let n = 0; 
                for (const key of Object.keys(formValues)) {
                  if (formValues[key] > 0 && key !== '11050001') n++; 
                }
                if (sub['11050005'] > 0 || formValues['11050001'] > 0) n++;
                return n;
              }

              const n = getN();
              const numerator = Object.values(formValues).reduce((a, b) => a + b, 0);
              return n > 0 ? Math.round((numerator / n) * 10) / 10 : 0;
            }
          },
          {
            target: '11020002',
            sources: [],
            computeFunction: () => {return 0;}
          },
          {
            target: '11030001',
            sources: ['11030002'],
            computeFunction: () => {
              const a = this.indicatorValues['11030002']; 
              return a === 'true' ? 100 : 0;
            }
          },
          {
            target: '11040001',
            sources: ['11040002'],
            computeFunction: () => {
              const a = this.indicatorValues['11040002']
              return a === 'true' ? 100 : 0;
            }
          },
          {
            target: '12020001',
            sources: [...this.generateIndicatorCodes('12', '0001', 3, 6, 1)],
            computeFunction: () => {
              const formValues = this.getFormValues(
                  [...this.generateIndicatorCodes('12', '0001', 3, 6, 1)]
              );              
              const vals = Object.values(formValues);
              if (vals.every(val => val === 0)) {
                  return 0; 
              }
              
              let n = 0; 
              for (const val of vals) {
                n += val > 0 ? 1 : 0; 
              }
              return n > 0 ? Math.round((vals.reduce((a, b) => a + b, 0) / n)*10) / 10 : 0;
            }
          }, 
          {
            target: '12020002',
            sources: ['12030001'], 
            computeFunction: () => {
              return this.indicatorValues['12030001']
            }
          },
          {
            target: '12030001',
            sources: ['12030002'], 
            computeFunction: () => {
              return this.indicatorValues['12030002'] === 'true' ? 100 : 0;
            }
          }, 
          {
            target: '12040001',
            sources: ['12040002'], 
            computeFunction: () => {
              return this.indicatorValues['12040002'] === 'true' ? 100 : 0;
            }
          },
          {
            target: '12050001',
            sources: ['12050002', '12050003'], 
            computeFunction: () => {
              const a = this.indicatorValues['12050002'] === 'true';
              const b = this.indicatorValues['12050003'] === 'true';
              if (a && b) return 100; 
              if (a || b) return 50;
              if (!a && !b) return 0;   
            }
          },    
          {
            target: '12060001',
            sources: ['12060002'], 
            computeFunction: () => {
              return this.indicatorValues['12060002'] === 'true' ? 100 : 0;
            }
          }
      ];
    }


    get flatIndicators() {
        return this.computedIndicators.reduce((acc, dep) => {
            dep.sources.forEach(src => {
                acc[src] = this.indicatorValues[src];
            });
            return acc;
        }, {} as Record<string, number | null | undefined>);
    }

    @Watch('flatIndicators', { deep: true })
    onFlatIndicatorsChanged(
        newValues: Record<string, number | null | undefined>,
        oldValues: Record<string, number | null | undefined>
    ) {
        const targetArr = this.computedIndicators.map(dep => dep.target);
        this.computedIndicators
            .filter(dep => targetArr.includes(dep.target))
            .forEach(dep => {
                const hasChanged = dep.sources.some(
                    key => newValues[key] !== oldValues[key]
                );
                if (hasChanged) {
                    this.computeFieldValue(dep);
                }
            });
    }

    getFormValues(sources: string[]): Record<string, number> {
      const result: Record<string, number> = {};
      for (const source of sources) {
          const formVal = this.indicatorValues[source];
          
          if (formVal === null || formVal === undefined || formVal === '') {
              result[source] = 0;
              continue;
          }
          
          if (typeof formVal === 'string') {
              result[source] = this.toNumber(formVal) || 0;
          } else {
              result[source] = Number(formVal) || 0;
          }
      }
      return result;
    }

    computeIndicatorWeightedAverage(
        ab: string,
        cd: string,
        formValues: Record<string, number>
    ): number | null {
        const key = (suffix: string) => `${ab}${cd}${suffix}`;
        const a = formValues[key("0002")];
        const b = formValues[key("0003")];
        const c = formValues[key("0004")];
        const d = formValues[key("0005")];
        const e = formValues[key("0006")];
        const f = formValues[key("0007")];

        const first = (a - (b * 0.15) - (c * 0.9)) / (a + d);
        const second = (a - (e * 0.1)) / a;
        const third = 1 - (f / 100);

        const validParts = [first, second, third].filter(Number.isFinite);
        const res =
            validParts.length > 0
                ? (validParts.reduce((sum, val) => sum + val, 0) / 3) * 100
                : null;
        return res;
    }

    computeDependentFields(changedIndicatorCode: string) {
        const affectedDependencies = this.computedIndicators.filter(dep =>
            dep.sources.includes(changedIndicatorCode)
        );

        affectedDependencies.forEach(dependency => {
            this.computeFieldValue(dependency);
        });
    }

    computeFieldValue(dependency: ComputedIndicator) {
        const computedValue = dependency.computeFunction();
        this.$set(this.indicatorValues, dependency.target, computedValue);
        this.formatNumberOnBlur(dependency.target);
    }

    isComputedField(indicatorCode: string): boolean {
        return this.computedIndicators.some(dep => dep.target === indicatorCode);
    }

    generateIndicatorCodes(
        ab: string,
        cd: string,
        mmin: number,
        mmax: number,
        pos: number = 2
    ): string[] {
        const res = [];
        if (pos === 1) {
            const key = (suffix: string) => `${ab}${suffix}${cd}`;
            for (let i = mmin; i <= mmax; i++) {
                const suff = i.toString().padStart(2, '0');
                res.push(key(suff));
            }
        } else if (pos === 2) {
            const key = (suffix: string) => `${ab}${cd}${suffix}`;
            for (let i = mmin; i <= mmax; i++) {
                const suff = i.toString().padStart(4, '0');
                res.push(key(suff));
            }
        }
        return res;
    }

    async fetchOjFromDb(): Promise<void> {
      try {
        if (this.filterData?.direction?.code !== '08') {
          this.oj = 0;
          return; 
        }
        const formYear = this.currYear - 1;  
        const response = await fetch(`/api-py/srs/form/computed/sm-data-item?formYear=${formYear}`);
        if (!response.ok) {
          throw new Error(`HTTP ${response.status}: ${response.statusText}`);
        }
        this.oj = await response.json();
      } catch (error) {
        const err = error as Error;
        this.makeToast(
          'danger', 
          'Error fetching fetchOjFromDb()', 
          err.message || err.toString()
        );
      }
    }

    async getAteForComputedIndicator(filterData: FilterData) {
        if (filterData.direction.code !== '06') return;
        this.compAte = this.filterData?.ate?.code;
        if (this.compAte === null) {
            this.compAte = await this.fetchAteForComputedIndicators(filterData);
        }
    }

    async fetchAteForComputedIndicators(filterData: FilterData) {
        try {
            const response = await fetch(
                `/api-py/srs/computed/${this.obl.code}?dist=${filterData.district.code}&rurDist=${filterData.ruralDistrict.code}&snp=${filterData.snp.code}&lang=${this.getNormalizedLocale()}`
            );
            if (!response.ok) {
                throw new Error('Error fetching fetchAteForComputedIndicators()');
            }
            const ateResp = await response.json();
            return ateResp;

        } catch (error) {
            const err = error as Error;
            this.makeToast(
                'danger',
                'Error fetching fetchAteForComputedIndicators()',
                err.message || err.toString()
            );
        }
    }

    // computed indicators

    getNormalizedLocale(locale=this.$i18n.locale): string {
        return (locale === 'kk' || locale === 'kz') ? 'kz' : 'ru';
    }

    @Watch('$i18n.locale', { immediate: false })
    async onLocaleChange(newLocale: string, oldLocale: string) {
        if (newLocale.trim() === '') {
            return;
        }
        if (this.filterData?.snp?.code) {
            await this.getSrsIndicators(this.getNormalizedLocale(newLocale));
        }
    }

    @Watch('filterData', { immediate: true })
    async onFilterDataChange(newFilterData: FilterData | null) {
        if (newFilterData) {
            // Update from filter
            if (newFilterData.direction) {
                this.dirCode = newFilterData.direction.code;
                this.isEducation = this.dirCode === '01';
            }
            if (newFilterData.year) {
                this.currYear = newFilterData.year.year;
            }
            await this.getSrsIndicators(this.getNormalizedLocale());
            await this.fetchOjFromDb();
            await this.loadExistingFormData(newFilterData);
            await this.getAteForComputedIndicator(newFilterData);
            await this.fetchFormStatus();

        } else {
            this.dirCode = '01';
            this.currYear = new Date().getFullYear();
            // Reload indicators
            if (this.filterData?.snp?.code) {
                await this.getSrsIndicators(this.getNormalizedLocale());
            }
        }

    }

    async mounted() {
        await this.getObl();
        await this.getUserAccessLevel();
        await this.getSrsIndicatorsRels(this.getNormalizedLocale());
        await this.fetchFormStatus();
    }

    async getUserAccessLevel() {
        try {
            const userData = {
                userId: this.$store.getters.user_uuid,
                moduleCode: this.moduleCode || '003.009.001'
            };

            const response = await fetch('/api-py/srs/user/', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(userData),
            });

            if (!response.ok) {
                throw new Error(`HTTP ${response.status}: ${response.statusText}`);
            }
            const accessLevel = await response.json();
            this.userAccessLevel = accessLevel;

        } catch (error) {
            this.userAccessLevel = 1; // default to level 1 on error
            const err = error as Error;
            this.makeToast(
                'danger',
                String(this.$t('modules.srs.warnings.getUserAccessLevel_error')),
                err.message || err.toString()
            );

        }
    }

    async getObl(): Promise<void> {
        try {
            const response = await fetch(`/api-py/get-budget-obl/${this.$store.state._instanceCode}`)
            this.obl = await response.json();
        } catch (error) {
            const err = error as Error;
            this.makeToast(
                'danger',
                String(this.$t('modules.srs.warnings.get_obl_error')),
                err.message || err.toString()
            );
        }
    }


    async onClickSaveForm() {
        if (!this.filterData) {
            this.makeToast(
                'warning',
                String(this.$t('modules.srs.warnings.filter_not_applied')),
                String(this.$t('modules.srs.warnings.warning')));
            return;
        }

        // Поля Категория и Статус должны быть заполнены
        if (this.isEducation) {
            if (!this.currCategory || !this.currStatus) {
                this.makeToast(
                    'warning',
                    String(this.$t('modules.srs.warnings.category_or_status_not_selected')),
                    String(this.$t('modules.srs.warnings.warning')));
                return;
            }
        }

        // Clear previous errors before validation
        this.errorIndicators = {};

        // Validate form values
        for (const ind of this.indicators) {
            if (ind.indicator_type == 'value_num') {
                this.handleFormValuesOnSave(ind);
                this.validateMbValue(ind);
            }
            for (const subind of ind.subindicators || []) {
                if (!this.indicatorValues[subind.id]) {
                    continue;
                }

                if (subind.indicator_type == 'value_num') {
                    this.handleFormValuesOnSave(subind);
                    this.validateMbValue(subind);
                }
            }
        }

        if (Object.keys(this.errorIndicators).length > 0) {
            // strict flk has priority
            for (const indicatorId of Object.keys(this.errorIndicators)) {
              if (indicatorId in this.diffWarnings && this.diffWarnings[indicatorId] !== '') {
                this.removeDiffWarning(indicatorId);
              }
            }
            this.makeToast(
                'danger',
                String(this.$t('modules.srs.warnings.data_save_error')),
                String(this.$t('modules.srs.warnings.warning')),
                4000 * (Object.keys(this.errorIndicators).length + 2)
            );
            return;
        }

        this.isSaving = true;

        try {
            // если нет данных для сохранении
            const formInputs = this.collectFormData();
            const allValuesNull = formInputs.every(input => input.value === null);
            if (allValuesNull || formInputs.length === 0) {
                this.isSaving = false;
                return;
            }

            const saveData = this.prepareFormData(formInputs);
            await this.saveFormDataToDb(saveData);
            this.makeToast(
                'success',
                String(this.$t('modules.srs.warnings.data_saved')),
                String(this.$t('modules.srs.warnings.data_saved'))
            );

            // // Delay the reset to allow toast to show
            // setTimeout(() => {
            //     this.$emit('reset-form');
            // }, 2002);
        } catch (error) {
            const err = error as Error;
            this.makeToast(
                'danger',
                String(this.$t('modules.srs.warnings.data_save_error')),
                err.message || err.toString()
            );
        } finally {
            this.isSaving = false;
        }
    }


    handleFormValuesOnSave(item: Indicator | Subindicator) {
      const indicatorId = item.id;
      const value = this.toNumber(this.indicatorValues[indicatorId]);
      
      // '%' / 'м2 на 1 человек'
      if (item.unit === '%' || item.indicator_code === '08080003') {
        if (value !== null && value !== undefined && value > 100) { 
          this.addValidationError(
            indicatorId,
            this.$t('modules.srs.warnings.percent_error', { name: item.name }).toString()
          );

          this.$set(this.errorIndicators, indicatorId, true); 
          return; 
        }
      }

      // 'ед.' / 'тысяч м2' ('08080004')
      if (item.unit === 'ед.' || item.unit === 'бірлік' || item.indicator_code === '08080004') {
        if (value !== null && value !== undefined && item.indicator_code !== '08080004') {

          if (!Number.isInteger(value)) {
              this.addValidationError(
                indicatorId,
                this.$t('modules.srs.warnings.whole_number_error', { name: item.name }).toString()
              );

              this.$set(this.errorIndicators, indicatorId, true); 
              return; 
          }
        }

        if (item.indicator_code in this.indicatorRels['data']) {
          const pars = this.indicatorRels.data[item.indicator_code]['parents'];
          const parValue = this.toNumber(this.indicatorValues[pars[0].indicator_code]);

          // indicator has one par
          if (pars.length === 1) {
            // par has no value
            if (value && ((parValue === null || parValue === undefined))) {
              this.addValidationError(
                indicatorId,
                this.$t('modules.srs.warnings.parent_no_val_error', { name: pars[0].name }).toString()
              );

              this.$set(this.errorIndicators, indicatorId, true); 
              return;
            }
            // child's value > par value
            if (value && parValue && (value > parValue)) {              
              this.addValidationError(
                indicatorId,
                this.$t('modules.srs.warnings.parent_error', { child: item.name, name: pars[0].name }).toString(), 
              );
              this.$set(this.errorIndicators, indicatorId, true); 
              return;
            }
          } 
        }
      }

      if (item.unit === 'км') {
        if (item.indicator_code in this.indicatorRels['data']) {
          const pars = this.indicatorRels.data[item.indicator_code]['parents'];
          const parValue = this.toNumber(this.indicatorValues[pars[0].indicator_code]);
          // par has no value
          if (parValue === null || parValue === undefined) {
            this.addValidationError(
                indicatorId,
                this.$t('modules.srs.warnings.parent_no_val_error', { name: pars[0].name }).toString(), 
              );
            this.$set(this.errorIndicators, indicatorId, true); 
            return;

          } else if (value && parValue && (value > parValue)) {
            this.addValidationError(
              indicatorId,
              this.$t('modules.srs.warnings.parent_error', { child: item.name, name: pars[0].name }).toString(), 
            );
            this.$set(this.errorIndicators, indicatorId, true); 
            return;
          }
        }
      }
    }

    collectFormData(): any[] {
        const formData: any[] = [];

        // Collect main indicator values
        this.indicators.forEach(indicator => {
            if (indicator.indicator_type) {
                const value = this.getInputValue(indicator.id, indicator.indicator_type);
                formData.push({
                    indicatorId: indicator.id,
                    indicatorName: indicator.name,
                    indicatorCode: indicator.indicator_code,
                    value: this.isValidValue(value) ? value : null,
                    type: indicator.indicator_type
                });
            }

            // Collect subindicator values
            indicator.subindicators?.forEach(subindicator => {
                const value = this.getInputValue(subindicator.id, subindicator.indicator_type);
                formData.push({
                    indicatorId: subindicator.id,
                    indicatorName: subindicator.name,
                    indicatorCode: subindicator.indicator_code,
                    value: this.isValidValue(value) ? value : null,
                    type: subindicator.indicator_type
                });
            });
        });

        return formData;
    }

    getInputValue(indicatorId: string, indicatorType: string | null): any {
      if (indicatorType === 'value_num') {
          const input = document.querySelector(`input[data-indicator="${indicatorId}"]`) as HTMLInputElement;
          return input && input.value ? this.toNumber(input.value) : null;
      } 
      else if (indicatorType === 'value_boolean') {
          const radio = document.querySelector(`input[name="indicator-${indicatorId}"]:checked`) as HTMLInputElement;
          return radio ? radio.value === 'true' : null;
      }
      return null;
    }


    prepareFormData(formInputs: any[]) {
      return formInputs.map(input => ({
          ate_code: this.filterData!.ate ? this.filterData!.ate.code : null,
          year: this.filterData!.year.year,
          code_kato1: this.filterData!.district?.code || '',
          code_kato2: this.filterData!.ruralDistrict?.code || '',
          code_kato3: this.filterData!.snp?.code || '',
          indicator_name: input.indicatorName,
          indicator_code: input.indicatorCode,
          category_code: this.isEducation ? this.currCategory?.id : null,
          status_code: this.isEducation ? this.currStatus?.id : null,
          // Conditional value assignment based on indicator type
          ...(input.type === 'value_num' ? 
              { 
                  value_num: this.isValidValue(input.value)
                    ? this.toNumber(input.value)
                    : null, 
                  value_boolean: null, 
                  value_text: null 
              } : 
              input.type === 'value_boolean' ? 
              { 
                  value_num: null, 
                  value_boolean: input.value, 
                  value_text: null 
              } : 
              { 
                  value_num: null, 
                  value_boolean: null, 
                  value_text: input.value 
              }
          )
      }));
    }

    toNumber(value: any): number | null {
      if (value === null || value === undefined || value === '') return null;
      const cleaned = value.toString().replace(/\s+/g, '').replace(',', '.');
      const num = Number(cleaned);
      return isNaN(num) ? null : num;
    }

    async saveFormDataToDb(data: any[]) {
        try {
            const response = await fetch(`/api-py/srs/form/save?lang=${this.$i18n.locale}`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ formData: data })
            });

            if (!response.ok) {
                const errorBody = await response.json().catch(() => null);
                const message = errorBody?.detail || `${this.$t('modules.srs.warnings.server_error')} (${response.status})`;

                // Check for specific validation error codes from backend
                if (response.status === 400) {
                    if (typeof message === 'object') {
                        if (message.error === 'neg_number_error') {
                            this.makeToast(
                                'warning',
                                this.$t('modules.srs.warnings.neg_number_error', { name: message.obj['name'] }).toString(),
                                String(this.$t('modules.srs.warnings.warning'))
                            );
                            this.$set(this.errorIndicators, message.obj['indicator_code'], true);
                        } else if (message.error === 'percent_error') {
                            this.makeToast(
                                'warning',
                                this.$t('modules.srs.warnings.percent_error', { name: message.obj['name'] }).toString(),
                                String(this.$t('modules.srs.warnings.warning'))
                            );
                            this.$set(this.errorIndicators, message.obj['indicator_code'], true);
                        } else if (message.error === 'whole_number_error') {
                            this.makeToast(
                                'warning',
                                this.$t('modules.srs.warnings.whole_number_error', { name: message.obj['name'] }).toString(),
                                String(this.$t('modules.srs.warnings.warning'))
                            );
                            this.$set(this.errorIndicators, message.obj['indicator_code'], true);
                        }  else if (message.error === 'mb_error') {
                            this.makeToast(
                                'warning',
                                this.$t('modules.srs.warnings.mb_error', { name: message.obj['name'] }).toString(),
                                String(this.$t('modules.srs.warnings.warning'))
                            );
                            this.$set(this.errorIndicators, message.obj['indicator_code'], true);
                        } else if (message.error === 'parent_error') {
                            this.makeToast(
                                'warning',
                                this.$t('modules.srs.warnings.parent_error', {
                                    child: message.obj['child']['name'],
                                    name: message.obj['par']['indicator_name']
                                }).toString(),
                                String(this.$t('modules.srs.warnings.warning'))
                            );
                            this.$set(this.errorIndicators, message.obj['child']['indicator_code'], true);
                        } else if (message.error === 'parent_no_val_error') {
                            this.makeToast(
                                'warning',
                                this.$t('modules.srs.warnings.parent_no_val_error', { name: message.obj.par[0]['name'] }).toString(),
                                String(this.$t('modules.srs.warnings.warning'))
                            );
                            this.$set(this.errorIndicators, message.obj['child']['indicator_code'], true);
                        } else if (message.error === 'parent_sum_error') {
                            this.makeToast(
                                'warning',
                                this.$t(
                                    'modules.srs.warnings.parent_sum_error',
                                    {name: message.obj['child']['name'], names: message.obj['par'].join(', ')}).toString(),
                                String(this.$t('modules.srs.warnings.warning'))
                            );
                            this.$set(this.errorIndicators, message.obj['child']['indicator_code'], true);
                        }
                    }

                } else {
                    // Non-validation errors (500, etc.)
                    this.makeToast(
                        'danger',
                        message.error,
                        String(this.$t('modules.srs.warnings.server_error'))
                    );
                }
                throw new Error(message.error);
            }
            return await response.json();

        } catch (error) {
            // Re-throw to be caught by the outer try-catch in onClickSaveForm
            throw error;
        }
    }


    async getSrsIndicators(locale: string) {
        try {

            const ateCode = this.filterData?.ate?.code !== null ? this.filterData?.ate?.code : '0';
            const dist = this.filterData?.district?.code;
            const rurDist = this.filterData?.ruralDistrict?.code;
            const snp = this.filterData?.snp?.code;
            const obl = this.filterData?.snp?.code.substring(0, 2);

            const response = await fetch(`/api-py/srs/form/indicators/${obl}?dirCode=${this.dirCode}&ateCode=${ateCode}&distCode=${dist}&rurCode=${rurDist}&snpCode=${snp}&lang=${locale}`);
            this.indicators = await response.json();
            if (this.dirCode === '01') {
                const eduLocale = this.$i18n.locale === 'kk' ? 'kz' : this.$i18n.locale;
                const snp = this.filterData?.snp;
                const ateCode = this.filterData?.ate?.code ? this.filterData?.ate?.code : '0';

                if (this.filterData?.snp?.code !== null && this.filterData?.snp?.code !== undefined && this.filterData?.snp?.code !== '') {
                  const catResponse = await fetch(`/api-py/srs/form/srs-categories/${obl}?snpCode=${snp.code}&lang=${eduLocale}`);
                  this.categoriesList = await catResponse.json(); 
                  this.currCategory = this.categoriesList[0] || null; 

                  const statResponse = await fetch(`/api-py/srs/form/srs-status/${obl}?ateCode=${ateCode}&distCode=${dist}&rurCode=${rurDist}&snpCode=${snp.code}&lang=${eduLocale}`);
                  this.statusList = await statResponse.json();
                  this.currStatus = null;
                  this.isEducation = true; 
                }
            }

        } catch (error) {
            const err = error as Error;
            this.makeToast('danger', String(this.$t('modules.srs.warnings.indicator_get_error')), err.message || err.toString());
        }
    }


    async getSrsIndicatorsRels(locale: string) {
        try {
            const response = await fetch(`/api-py/srs/form/indicators/rels?lang=${locale}`);
            this.indicatorRels = await response.json();
        } catch (error) {
            const err = error as Error;
            this.makeToast(
                'danger',
                String(this.$t('modules.srs.warnings.getSrsIndicatorsRels_error')),
                err.message || err.toString()
            );
        }
    }


    async loadExistingFormData(filterData: FilterData) {
        try {
            // Clear form when incomplete filter
            if (!filterData.district || !filterData.ruralDistrict || !filterData.snp || !filterData.direction || !filterData.year) {
                this.existingFormData = {};
                this.indicatorValues = {};
                this.historicalValues = {};
                return;
            }

            const response = await fetch(
                `/api-py/srs/form/data?year=${filterData.year.year}&code_kato1=${filterData.district.code}&code_kato2=${filterData.ruralDistrict.code}&code_kato3=${filterData.snp.code}&dirCode=${this.dirCode}`
            );

            if (response.ok) {
                const respYearData = await response.json();
                this.historicalValues = respYearData;
                this.existingFormData = respYearData[filterData.year.year]
                // update all bound inputs
                await this.prefillFormFields();
                
                // non-strict flk check on form load
                for (const ind of this.indicators) {
                  this.handleFlkJumpCheck(ind);
                  for (const subind of ind.subindicators || []) {
                    this.handleFlkJumpCheck(subind);
                  }
                }

            } else {
                // NO DATA: Show empty form
                this.existingFormData = {};
                this.indicatorValues = {};
                this.historicalValues = {};
            }
        } catch (error) {
            this.existingFormData = {};
            this.indicatorValues = {};
            this.historicalValues = {};
        }
    }


    async prefillFormFields() {
        this.indicatorValues = {};

        // previous year duplication logic
        this.clearSessionStorage();
        const stored = sessionStorage.getItem('duplicationOptions');
        const storedData = stored ? JSON.parse(stored) : null;
        const option = storedData?.selectedDuplicationOption;

        const prevYear = this.filterData!.year.year - 1; 
        if (option && (option === 'all' || option === this.filterData!.direction.code)) {
          this.existingFormData = this.historicalValues[prevYear]
        }
        
        // education-specific fields (Category and Status)
        if (this.isEducation) {
            const firstDataEntry = Object.values(this.existingFormData)[0] as any;

            if (firstDataEntry) {
                if (firstDataEntry.category_code) {
                    this.currCategory = this.categoriesList.find(cat =>
                        cat.id === firstDataEntry.category_code.toString()
                    ) || null;
                }
                if (firstDataEntry.status_code) {
                    this.currStatus = this.statusList.find(status =>
                        status.id === firstDataEntry.status_code.toString()
                    ) || null;
                }
            } else {
                this.currCategory = null;
                this.currStatus = null;
            }
        }

        this.indicators.forEach(indicator => {
            if (indicator.indicator_type) {
                // Set value for main indicator
                this.setIndicatorValue(indicator.id, indicator.indicator_code);
            }
            // Set values for all subindicators
            indicator.subindicators?.forEach(subindicator => {
                this.setIndicatorValue(subindicator.id, subindicator.indicator_code);
            });
        });

        const val = this.indicatorValues['08040003'];
        this.waterSupplyDisabled = val === 'false' || val === false;
        // set 08040010 = true, if 08040011/12/13 = true
        this.syncWaterSupplyIndicators(); 

        // force reactivity refresh for inputs
        await this.$nextTick();
        const currentValues = { ...this.indicatorValues };
        this.indicatorValues = {};
        await this.$nextTick();
        this.indicatorValues = currentValues;
    }

    setIndicatorValue(indicatorId: string, indicatorCode: string) {

        const computed = this.computedIndicators;
        computed.forEach(indicator => { 
            if (indicator.target === indicatorId) {
              const codes = indicator.sources || [];
              const allEmpty = codes.every(code => {
                const val = this.indicatorValues[code];
                return val === null || val === undefined || val === '';
              });
              if (allEmpty) {
                this.indicatorValues[indicatorId] = 0;
                return; 
              };
            }
        })

        const dataKey = this.findDataKey(indicatorCode);
        if (!dataKey) return;

        const data = this.existingFormData[dataKey];
        if (!data) return;

        // update the bound input
        if (data.value_num !== null && data.value_num !== undefined) {
            this.indicatorValues[indicatorId] = Number(data.value_num);
            this.formatNumberOnBlur(indicatorId);
        } else if (data.value_boolean !== null && data.value_boolean !== undefined) {
            this.indicatorValues[indicatorId] = data.value_boolean.toString();
        } else if (data.value_text !== null && data.value_text !== undefined) {
            this.indicatorValues[indicatorId] = data.value_text;
        }
    }


    findDataKey(indicatorCode: string): string | null {
        const keys = Object.keys(this.existingFormData);
        return keys.find(key => key === indicatorCode) || null;
    }

    getHistoricalValue(indicatorCode: string, yearOffset: number): any {
        // yearOffset: 1 = 4 years ago, 2 = 3 years ago, 3 = 2 years ago, 4 = 1 year ago
        const year = this.currYear - (5 - yearOffset);

        if (!this.historicalValues[year] || !this.historicalValues[year][indicatorCode]) {
            return null;
        }

        const data = this.historicalValues[year][indicatorCode];

        if (data.value_num !== null && data.value_num !== undefined) {
            return this.formatNumberWithSpaces(data.value_num);
        } else if (data.value_boolean !== null && data.value_boolean !== undefined) {
            return data.value_boolean.toString();
        } else if (data.value_text !== null && data.value_text !== undefined) {
            return data.value_text;
        }

        return null;
    }

    getHistoricalCategoryStatus(yearOffset: number, isCategory: boolean): srsCategory | srsStatus | null {
        const year = this.currYear - (5 - yearOffset);

        if (!this.historicalValues[year]) {
            return null;
        }
        // Get the first entry's category code for that year
        const firstEntry = Object.values(this.historicalValues[year])[0] as any;

        if (isCategory) {
            if (firstEntry && firstEntry.category_code) {
                return this.categoriesList.find(cat =>
                    cat.id === firstEntry.category_code.toString()
                ) || null;
            }
        } else {
            if (firstEntry && firstEntry.status_code) {
                return this.statusList.find(status =>
                    status.id === firstEntry.status_code.toString()
                ) || null;
            }
        }
        return null;
    }

    handleNumberInput(item: Indicator | Subindicator) {
        const indicatorId = item.id;
        let value = this.indicatorValues[indicatorId];

        // non strict flk (user clears input)
        const isValueEmpty = value === null || value === undefined || value === '';
        if (isValueEmpty) {
            this.$set(this.diffWarnings, indicatorId, '');
        }

        // Clear error state when user modifies the input
        this.clearValidationError(indicatorId);

        // Clean and validate
        if (typeof value === 'string') {
            value = value.replace(/\s/g, '');
            // Check again after cleaning spaces
            if (value === '') {
                this.indicatorValues[indicatorId] = null;
                this.$nextTick(() => {
                    this.computeDependentFields(indicatorId);
                });
                return;
            }
        }

        if (!isNaN(value)) {
          if (value < 0) {
            this.makeToast(
              'warning', 
              String(this.$t('modules.srs.warnings.neg_number_error', { name: item.name })), 
              String(this.$t('modules.srs.warnings.warning'))
            );
            this.indicatorValues[indicatorId] = null; 
            return; 
          }
        }
        this.indicatorValues[indicatorId] = value;
        this.limitToThreeDecimals(indicatorId);

        // Trigger computation for any fields that depend on this one
        this.$nextTick(() => {
            this.computeDependentFields(indicatorId);
        });
    }


    formatNumberOnBlur(indicatorId: string) {
      const value = this.indicatorValues[indicatorId];
      if (value !== null && value !== undefined && value !== '') {
        this.indicatorValues[indicatorId] = this.formatNumberWithSpaces(value);
      }
    }

    formatNumberWithSpaces(value: any): string {
      if (!value && value !== 0) return "";
      // Convert to number if string
      const numValue = typeof value === 'string' 
        ? this.toNumber(value)
        : value;

      if (isNaN(numValue)) return "";

      // Split into integer and decimal parts
      const parts = numValue.toString().split('.');
      const intPart = parts[0];
      const decPart = parts[1];
      // Add space as thousand separator
      const intFormatted = intPart.replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
      return decPart !== undefined ? `${intFormatted},${decPart}` : intFormatted;
    }

    removeFormattingOnFocus(indicatorId: string) {
      const value = this.indicatorValues[indicatorId];
      if (typeof value === 'string') {
        const numValue = this.toNumber(value);
        if (numValue && !isNaN(numValue)) {
          this.indicatorValues[indicatorId] = numValue;
        }
      }
    }

    blockInvalidChars(e: KeyboardEvent | null) {
        if (!e) return;
        const key = e.key || '';
        const input = e.target as HTMLInputElement;
        const controlKeys = ['Backspace', 'Delete', 'Tab', 'Escape', 'Enter', 
                            'ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown', 'Home', 'End'];
        if (e.ctrlKey || e.metaKey || controlKeys.includes(key)) {
            return;
        }
        // Only allow digits 0-9 and decimal point
        if (!/^[0-9.,]$/.test(key)) {
            e.preventDefault();
            return;
        }
        // Prevent more than one decimal separator (dot OR comma)
        if ((key === '.' || key === ',') && /[.,]/.test(input.value)) {
          e.preventDefault();
        }
    }

    validateParSum(item: Indicator | Subindicator) {
        const indicatorId = item.id;
        const value = this.indicatorValues[indicatorId];

        const pars = this.indicatorRels.data[item.indicator_code]['parents'];
        // indicator has more than one par
        if (pars.length > 1) {
            const parSum = this.computeParSum(pars);
            if (parSum === 0) {
                return;
            }
            if (value < parSum) {
                this.makeToast(
                    'warning',
                    this.$t(
                        'modules.srs.warnings.parent_sum_error',
                        { name: item.name, names: pars.map(par => par.name).join(', ') }).toString(),
                    String(this.$t('modules.srs.warnings.warning')
                    )
                )
                return;
            }
        }
    }

    validateMbValue(item: Indicator | Subindicator) {
      const indicatorId = item.id;
      const value = this.toNumber(this.indicatorValues[indicatorId]);
      
      // MB validation
      if (item.indicator_code === '10050003') {
        if (value && !(value === 50 || value === 100)) {
          this.addValidationError(
            indicatorId,
            this.$t('modules.srs.warnings.mb_error', { name: item.name }).toString(), 
          );
          this.$set(this.errorIndicators, indicatorId, true); 
          return;
        }
      }
    }


    computeParSum(pars: (Indicator | Subindicator)[]): number {
      const parSum = pars.reduce((sum: number, par: Indicator | Subindicator) => {
        const value = this.toNumber(this.indicatorValues[par.indicator_code]) || 0;
        return sum + value;
      }, 0);

        return parSum;
    }

    limitToThreeDecimals(indicatorId: string) {
        let value = this.indicatorValues[indicatorId];
        value = this.toNumber(value);
        if (!isNaN(value)) {
            if (value === 0) {
                this.indicatorValues[indicatorId] = 0;
            } else if (value > 0 && value < 0.001) {
                // Round up very small positive values to 0.001
                this.indicatorValues[indicatorId] = 0.001;
            } else {
                // Normal rounding to 3 decimal places
                const valueStr = value.toString();
                if (valueStr.includes('.')) {
                    const parts = valueStr.split('.');
                    if (parts[1].length > 3) {
                        const rounded = (parseFloat(parts[0] + '.' + parts[1].slice(0, 3)).toFixed(3));
                        this.indicatorValues[indicatorId] = parseFloat(rounded);
                    }
                }
            }
        }
      }

    isValidValue(value: any) {
      if (value !== null && value !== undefined && value !== '' && !isNaN(value)) {
        return true;
      }
      return false;
    }


    toggleVisibility(item: Indicator | Subindicator): void {
        item.open = !item.open;
    }

    toggleAll() {
        this.allOpen = !this.allOpen;
        this.indicators.forEach(item => {
            item.open = this.allOpen;
            item.subindicators.forEach(subitem => {
                if (Object.keys(this.special06SubindicatorGroups).includes(subitem.id)) {
                    subitem.open = this.allOpen
                }
            })
        });
        if (this.dirCode === '01') {
            this.isEducation = this.allOpen;
        }
    }

    get special06SubindicatorGroups() {
        return {
            '06030003': this.generateIndicatorCodes('06', '03', 4, 8),
            '06030010': this.generateIndicatorCodes('06', '03', 11, 15),
            '06030017': this.generateIndicatorCodes('06', '03', 18, 22)
        };
    }

    get allSpecial06SubindicatorIds(): string[] {
        return Object.values(this.special06SubindicatorGroups).flat();
    }

    shouldShowSubitem(item: Indicator, subitem: Subindicator): boolean {
        if (!item.open) return false;
        // Check which parent this subitem belongs to
        for (const [parentId, childIds] of Object.entries(this.special06SubindicatorGroups)) {
            if (childIds.includes(subitem.id)) {
                const par = item.subindicators.find((s: Subindicator) => s.id === parentId);
                return par?.open === true;
            }
        }
        // For all other subindicators, just need item.open
        return true;
    }

    isSpecial06Subitem(subitemId: string): boolean {
        return this.allSpecial06SubindicatorIds.includes(subitemId);
    }

    makeToast(variant: string, tostbody: string, title: string, autoHideDelay?: number): void {
        this.$bvToast.toast(tostbody, {
            title: title,
            variant: variant,
            autoHideDelay: autoHideDelay || 3500,
            solid: true
        });
    }

    // validation 
    addValidationError(indicatorId: string, errorMessage: string) {
      if (!this.validationErrors[indicatorId]) {
          this.$set(this.validationErrors, indicatorId, []);
      }
      if (!this.validationErrors[indicatorId].includes(errorMessage)) {
          this.validationErrors[indicatorId].push(errorMessage);
      }
    }

    clearValidationError(indicatorId: string) {
        this.$delete(this.validationErrors, indicatorId);
        this.$delete(this.errorIndicators, indicatorId);
    }
    // validation

    isBlockedForEdit(indicatorId: string): boolean {
      const unblockedRegions = ['11', '27'];
      const editableStatusCodes = [80, 82];

      const isYear2024 = this.filterData?.year?.year === 2024;

      const isRegionBlocked =
        isYear2024 && !unblockedRegions.includes(this.obl?.code);

      const isStatusBlocked =
        !editableStatusCodes.includes(this.formStatus);

      // indicators disabled if decentralized water supply (08040010) is false
      const SupplyIndicatorsToDisable = ['08040011', '08040012', '08040013']; 
      const isDecWaterSupplyFalse = (
        this.indicatorValues['08040010'] === 'false' 
        || this.indicatorValues['08040010'] === false
      );
      const isDecWaterSupplyBlocked = (
        SupplyIndicatorsToDisable.includes(indicatorId) && isDecWaterSupplyFalse
      ); 

      return isRegionBlocked || isStatusBlocked || isDecWaterSupplyBlocked;
    }

    async fetchFormStatus() {
      try {
        const snpCode = this.filterData?.snp?.code;
        const dirCode = this.filterData?.direction?.code;
        const year = this.filterData?.year?.year;

        const response = await fetch(`/api-py/srs/agree/form/status?snpCode=${snpCode}&dirCode=${dirCode}&year=${year}`);
        if (!response.ok) {
          throw new Error(`HTTP ${response.status}: ${response.statusText}`);
        }
        this.formStatus = await response.json();
      } catch (error) {
        console.error('Error fetching fetchFormStatus()', error);
      }
    }

    focusNextInput(e: KeyboardEvent) {
      e.preventDefault();

      const allInputs = Array.from(
          this.$el.querySelectorAll('input[data-indicator]:not([disabled])')
      ) as HTMLInputElement[];
      
      const current = e.target as HTMLInputElement;
      const currentIndex = allInputs.indexOf(current);
      if (currentIndex !== -1 && currentIndex < allInputs.length - 1) {
          allInputs[currentIndex + 1].focus();
      }
    }


    clearWaterSupplyValues() {
      this.waterSupplyIndicators.forEach(indicator => {
        this.indicatorValues[indicator] = null;
      });
    }

    onRadioButtonChange(indicatorId: string) {
      this.$nextTick(() => {
        this.computeDependentFields(indicatorId);
        this.handleWaterSupplyButtonChange(indicatorId);
        this.handleDecWaterSupplyButtonChange(indicatorId);
      }); 
      this.handleWaterSupplyTypesButtonChange(indicatorId);
    }

    showConfirmDeletionModal(indicatorId: string) {
      this.getWaterSupplyIndicatorNames(); 
      const mod = (this.$refs.confirmDeletionModal as InstanceType<typeof ConfirmDeletionModal>); 
      mod.show();
    }

    async handleWaterSupplyButtonChange(indicatorId: string) {
      const isWaterSupplyIndicator = indicatorId === '08040003'; 
      if (!isWaterSupplyIndicator) return; 
      const isTrue = (
        this.indicatorValues['08040003'] === 'true' 
        || this.indicatorValues['08040003'] === true
      ); 
      if (isTrue) {
        this.waterSupplyIndicatorNames = []; 
        this.waterSupplyDisabled = false;
        return; 
      }
    
      await this.fetchWaterSupplyFromDb(); 
      if (this.waterSupplyIndicatorsDb.length === 0) {
        this.clearWaterSupplyValues();
        this.waterSupplyIndicatorNames = [];
        this.waterSupplyDisabled = true; 
      } else {
        this.showConfirmDeletionModal(indicatorId);
      }
      
    }
    
    handleCloseConfirmDeletionModal() {
      this.waterSupplyIndicatorNames = []; 
      this.indicatorValues['08040003'] = null; 
      this.waterSupplyDisabled = false;
    }

    async handleConfirmDataDeletion() {  
      const indicatorCodes = this.waterSupplyIndicatorsDb.map(indicator => indicator[0]);
      const dto = {
        year: this.currYear,
        code_kato1: this.filterData!.district.code,
        code_kato2: this.filterData!.ruralDistrict.code,
        code_kato3: this.filterData!.snp.code,
        indicator_codes: indicatorCodes,
      }

      const res = await this.deleteSrsFormData(dto);
      if (res.ok) {
        this.clearWaterSupplyValues(); 
        this.waterSupplyIndicatorNames = [];
        // disable water supply fields 
        this.waterSupplyDisabled = true;
      }
    }

    async fetchWaterSupplyFromDb(): Promise<void> {
      const dto = {
        year: this.currYear,
        code_kato1: this.filterData!.district.code,
        code_kato2: this.filterData!.ruralDistrict.code,
        code_kato3: this.filterData!.snp.code,
        indicator_codes: this.waterSupplyIndicators
      }

      try {
        const response = await fetch(`/api-py/srs/form/data?year=${dto.year}&code_kato1=${dto.code_kato1}&code_kato2=${dto.code_kato2}&code_kato3=${dto.code_kato3}&dirCode=${this.dirCode}`
        );

        if (!response.ok) {
          throw new Error(`HTTP ${response.status}`);
        }
        const data = await response.json();
        const entries = Object.entries(data[dto.year]) as [string, ISrsFormIndicatorDb][];
        this.waterSupplyIndicatorsDb = entries.filter(([key]) => this.waterSupplyIndicators.includes(key));
          
      } catch (error) {
        const err = error as Error;
        this.makeToast(
          'danger',
          'Error fetching fetchWaterSupplyFromDb()',
          err.message || err.toString()
        );
      }
    }

    async deleteSrsFormData(dto: IWaterSupplyIndicatorDto) {
        try {
            const response = await fetch(`/api-py/srs/form/delete`, 
              {
                method: 'DELETE',
                headers: {
                  'Content-Type': 'application/json',
                },
                body: JSON.stringify(dto)
              }
            );

            const result = await response.json();
            if (!response.ok) {
              throw new Error(result?.message || `HTTP ${response.status}`);
            }
            return result 

        } catch (error) {
            const err = error as Error;
            this.makeToast(
              'danger',
              'Error deleting form data',
              err.message || err.toString()
            );
        }
    }

    get waterSupplyIndicators() {
      const waterSupplyIndicators = ['08040004', '08040006', '08040007', '08040008'];
      return waterSupplyIndicators; 
    }
    
    getWaterSupplyIndicatorNames(): string[] | void { 
      for (const mindicator of this.indicators) {
        for (const subindicator of mindicator.subindicators) {
          for (const el of this.waterSupplyIndicatorsDb) {
            if (subindicator.id === el[0]) {
             this.waterSupplyIndicatorNames.push(subindicator.name);
            }
          }
        }
      }
    }

    get selectedDuplicationOption(): string {
      return (
        this.prevDataDto.checkedOption   
        ? (this.prevDataDto.checkedOption === 'all' 
            ? 'all' 
            : this.prevDataDto.dirObj.code
          ) 
        : ''
      );
    }

    get duplicateData() {
      return {
        currYear: this.filterData!.year.year,
        prevYear: this.filterData!.year.year - 1,
        dirObj: {
          name: this.filterData!.direction!.name,
          code: this.filterData!.direction!.code,
        },
      };
    }

    handleShowDuplicationModal() {
      const modal =
        this.$refs.duplicatePrevYearDataModal as InstanceType<
          typeof DuplicatePrevYearDataModal
        >;
      modal.show();
    }

    handleShowDuplicationConfirmModal(data: IPrevData) { 
      this.prevDataDto = data;
      const modal = 
        this.$refs.duplicatePrevYearDataConfirmModal as InstanceType<
          typeof DuplicatePrevYearDataConfirmModal
        >;
      modal.show();
    }

    async handleDuplication() {
      try {
        sessionStorage.setItem(
          'duplicationOptions',
          JSON.stringify({
            userId: this.$store.getters.user_uuid,
            authSessionId: this.getAuthSessionId(this.$store.getters.token),
            selectedDuplicationOption: this.selectedDuplicationOption
          })
        );

        await this.prefillFormFields();

        setTimeout(() => {
          this.makeToast(
            'warning',
            String(this.$t('modules.srs.warnings.data_save_warning')),
            String(this.$t('modules.srs.warnings.information'))
          );
        }, 2000);

      } catch (error) {
        console.error('Duplication failed:', error);
      }
    }

    getAuthSessionId(token: string) {
      const sessionId = jwtDecode<{ sid: string }>(token).sid; 
      return sessionId;
    }

    clearSessionStorage() {
      const raw = sessionStorage.getItem('duplicationOptions');
      if (raw) {
        const stored = JSON.parse(raw);
        const currentSessionId = this.getAuthSessionId(this.$store.getters.token);
        const matchesSession = stored.authSessionId === currentSessionId;

        if (!matchesSession) {
          // clear if user has changed or logged out
          sessionStorage.removeItem('duplicationOptions');
        }
      }
    }

    handleDecWaterSupplyButtonChange(indicatorId: string) {
      const indicatorsToDisable = ['08040011', '08040012', '08040013'];
      const isEngInfraIndicator = indicatorId === '08040010'; 
      if (!isEngInfraIndicator) return; 

      const isFalse = (
        this.indicatorValues['08040010'] === 'false' 
        || this.indicatorValues['08040010'] === false 
      );

      if (isFalse) {
        indicatorsToDisable.forEach(id => {
          this.indicatorValues[id] = false; 
        });
      } else {
        indicatorsToDisable.forEach(id => {
          this.indicatorValues[id] = null; 
        })
      }
    }

    handleWaterSupplyTypesButtonChange(indicatorId: string) {
      const indicators = ['08040011', '08040012', '08040013'];
      if (!indicators.includes(indicatorId)) return; 

      const isTrue = (
        indicators.some(id => this.indicatorValues[id] === 'true' 
        || this.indicatorValues[id] === true)
      );

      if (isTrue) {
        this.indicatorValues['08040010'] = true;
      } else {
        this.indicatorValues['08040010'] = null;
      }
    }

    syncWaterSupplyIndicators(): void {
      const hasDependentTrue =
        this.indicatorValues['08040011'] === 'true' ||
        this.indicatorValues['08040011'] === true ||
        this.indicatorValues['08040012'] === 'true' ||
        this.indicatorValues['08040012'] === true ||
        this.indicatorValues['08040013'] === 'true' ||
        this.indicatorValues['08040013'] === true;

      if (hasDependentTrue) {
        this.indicatorValues['08040010'] = true;
      }
    }

    handleFlkJumpCheck(item: Indicator | Subindicator) {
      const indicatorId = item.id;
      const isJumpCheck = item.is_jump_check; 
      const currVal = this.toNumber(this.indicatorValues[indicatorId]);
      const histVal = this.toNumber(this.getHistoricalValue(item.id, 4));

      if (isJumpCheck) {
        if (currVal !== null && histVal !== null) {
          const diff = Math.abs(100 - (currVal * 100) / histVal);
          const sign = (currVal - histVal) > 0 ? '+' : '-';
          const message = (
            sign === '+' ? this.$t('modules.srs.warnings.flk_diff_30_warning_more') 
            : this.$t('modules.srs.warnings.flk_diff_30_warning_less')
          ); 

          this.$set(
            this.diffWarnings,
            item.id,
            diff > 30 ? message : ''
          );
        };
      };
    }

    handleOnKeyEnter(item: Indicator | Subindicator, e: KeyboardEvent) {
      if (e.key !== 'Enter') return;
      // flk jump check
      this.handleFlkJumpCheck(item);
      // next input on Enter
      this.focusNextInput(e);
    }

    okDiffWarning(itemId: string) {
      // close tooltip; icon stays 
      this.closeDiffWarning(itemId);
    }

    cancelDiffWarning(item: Indicator | Subindicator) {
      this.$set(this.diffWarnings, item.id, '');
      this.$set(this.indicatorValues, item.id, this.getHistoricalValue(item.id, 5));
      this.closeDiffWarning(item.id);
    }

    closeDiffWarning(itemId: string) {
      const tooltip = (this.$refs[`diff-warning-tooltip-${itemId}`] as any)?.[0];
      tooltip?.['_events']?.close?.[0]?.();
    }

    removeDiffWarning(itemId: string) {
      this.$set(this.diffWarnings, itemId, '');
      this.closeDiffWarning(itemId);
    }
}
